// GENERATED FILE - do not edit.
//
// Produced by tools/ContractsGen from JetsonCrm.Contracts, which is the single
// definition of every wire shape the server, the agents and this app share. The
// BuildCrmApp target in JetsonCrm.Api.csproj regenerates it, so an edit here would be
// undone by the next build - change the C# record instead.
//
// Conventions, and why:
//   * DTO members are camelCase, because that is what System.Text.Json and the
//     SignalR JSON protocol put on the wire.
//   * Constant holders keep their C# PascalCase keys: those are identifiers in code,
//     not JSON members, so one spelling means the two languages read alike.
//   * DateTime, DateTimeOffset, TimeSpan, Guid and byte[] are all `string` - every one
//     of them crosses as text. Dates arrive ISO-8601; src/format.ts is the only place
//     that decides whether one is an instant to localize or a calendar date to print.

// =====================================================================
//  Enums. Numeric on both sides - the API serializes integers, not names.
// =====================================================================

export enum ApprovalStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum AuditActorKind {
  Anonymous = 0,
  Staff = 1,
  Portal = 2,
  Device = 3,
  System = 4,
}

export enum AuditCategory {
  Other = 0,
  SignIn = 1,
  Account = 2,
  Customer = 3,
  Device = 4,
  RemoteAccess = 5,
  Billing = 6,
  Ticket = 7,
  Catalog = 8,
  Expense = 9,
  Software = 10,
  Monitoring = 11,
  Discovery = 12,
  Settings = 13,
  Backup = 14,
  Mail = 15,
  Security = 16,
  Portal = 17,
  KnowledgeBase = 18,
  Forum = 19,
  Server = 20,
  Sales = 21,
}

export enum AuditOutcome {
  Success = 1,
  Refused = 2,
  Failed = 3,
}

export enum BackupFrequency {
  Manual = 0,
  Hourly = 1,
  Daily = 2,
  Weekly = 3,
}

export enum BackupTrigger {
  Scheduled = 0,
  Manual = 1,
}

export enum CampaignRecipientKind {
  Lead = 0,
  CustomerContact = 1,
  Employee = 2,
}

export enum CampaignRecipientOutcome {
  Pending = 0,
  Sent = 1,
  Failed = 2,
  Skipped = 3,
}

export enum CampaignStatus {
  Draft = 0,
  Sending = 1,
  Sent = 2,
  Cancelled = 3,
}

export enum CatalogItemKind {
  Part = 0,
  Software = 1,
  Service = 2,
  Other = 3,
}

export enum CatalogPriceSource {
  CustomerPrice = 0,
  ListPrice = 1,
  CostPlusMarkup = 2,
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum DeviceEventCategory {
  Other = 0,
  Session = 1,
  Software = 2,
  Power = 3,
  Management = 4,
  Connectivity = 5,
}

export enum DeviceEventKind {
  Unknown = 0,
  Enrolled = 1,
  Approved = 2,
  Rejected = 3,
  Archived = 4,
  Restored = 5,
  DecommissionRequested = 6,
  AgentRemoved = 7,
  CameOnline = 8,
  WentOffline = 9,
  Logon = 10,
  Logoff = 11,
  Locked = 12,
  Unlocked = 13,
  RemoteLogon = 14,
  Boot = 15,
  Shutdown = 16,
  UnexpectedShutdown = 17,
  AgentStarted = 18,
  SoftwareInstalled = 20,
  SoftwareUninstalled = 21,
  SoftwareUpdated = 22,
  PatchInstalled = 23,
  PatchUninstalled = 24,
  UninstallRequested = 25,
  UpdateInstallRequested = 26,
  ActionCompleted = 27,
  ActionFailed = 28,
  RestartRequested = 29,
  MaintenanceStarted = 30,
  MaintenanceEnded = 31,
  RemoteSessionStarted = 32,
  RemoteSessionEnded = 33,
  AgentVersionChanged = 34,
  InventoryRefreshRequested = 35,
  AgentUpdatePushed = 36,
  WakeRequested = 37,
  SoftwareInstallRequested = 38,
  ShellCommandRun = 39,
  LocalUserCreated = 40,
  LocalUserPasswordReset = 41,
  LocalUserDisabled = 42,
  LocalUserEnabled = 43,
  ServiceControlled = 44,
  ServiceStartupChanged = 45,
  LocalUserDeleted = 46,
  ServiceStoppedUnexpectedly = 47,
  ServiceRecovered = 48,
  ServiceRecoveryChanged = 49,
  ServiceAccountChanged = 50,
  LocalUserGroupsChanged = 51,
  MobileCommandRequested = 52,
  MobileCommandCompleted = 53,
  LostModeStarted = 54,
  LostModeStopped = 55,
  LostModeLocation = 56,
  MobilePolicyChanged = 57,
  MobileComplianceChanged = 58,
  MobileManagementRemoved = 59,
  WindowsPolicyChanged = 60,
  WindowsComplianceChanged = 61,
  WindowsPolicyEnforced = 62,
  BitLockerKeyEscrowed = 63,
  ScreenLocked = 64,
  DeviceLocked = 65,
  DeviceUnlocked = 66,
}

export enum DeviceEventSeverity {
  Info = 0,
  Warning = 1,
  Error = 2,
}

export enum DeviceEventSource {
  Server = 0,
  Agent = 1,
}

export enum DiagnosticStatus {
  Ok = 0,
  Warning = 1,
  Failed = 2,
  Unknown = 3,
}

export enum DiscoveredDeviceKind {
  Unknown = 0,
  Computer = 1,
  Printer = 2,
  NetworkDevice = 3,
  Nas = 4,
  Ups = 5,
  IpCamera = 6,
  Other = 7,
  SynologyNas = 8,
  SynologyRouter = 9,
}

export enum ExpenseCategory {
  Payroll = 0,
  Subcontractor = 1,
  Software = 2,
  Hardware = 3,
  Rent = 4,
  Utilities = 5,
  Insurance = 6,
  Vehicle = 7,
  Marketing = 8,
  ProfessionalFees = 9,
  Training = 10,
  Telecom = 11,
  BankAndFees = 12,
  Tax = 13,
  Other = 14,
}

export enum FileOperationKind {
  Delete = 0,
  Rename = 1,
  CreateDirectory = 2,
}

export enum ForumAuthorKind {
  Staff = 0,
  Portal = 1,
}

export enum ForumPostDeletion {
  None = 0,
  ByAuthor = 1,
  ByModerator = 2,
}

export enum HostBillingInterval {
  Monthly = 0,
  Annual = 1,
}

export enum HostInvoiceEmailKind {
  Invoice = 0,
  Reminder = 1,
  Receipt = 2,
}

export enum HostPermission {
  None = 0,
  ManageOrganizations = 1,
  ManageUsers = 2,
  ManageServer = 4,
  ManageBilling = 8,
  All = 15,
}

export enum InboundMailKind {
  Unmatched = 0,
  InvoiceReply = 1,
  Bounce = 2,
  Ticket = 3,
  TicketReply = 4,
  Ignored = 5,
  CampaignReply = 6,
}

export enum InvoicePaymentStatus {
  Started = 0,
  Completed = 1,
  Failed = 2,
  Cancelled = 3,
  Pending = 4,
}

export enum InvoiceStatus {
  Draft = 0,
  Issued = 1,
  Paid = 2,
  Void = 3,
}

export enum KbAccessLevel {
  None = 0,
  Read = 1,
  Write = 2,
}

export enum KbArticleStatus {
  Draft = 0,
  Published = 1,
  Archived = 2,
}

export enum KbAuthorKind {
  Staff = 0,
  Portal = 1,
}

export enum KbVisibility {
  Public = 0,
  Private = 1,
  Internal = 2,
}

export enum LeadActivityKind {
  Note = 0,
  Call = 1,
  Email = 2,
  Meeting = 3,
  StatusChange = 4,
  Converted = 5,
  FormSubmitted = 6,
  CampaignSent = 7,
  Unsubscribed = 8,
}

export enum LeadSource {
  Manual = 0,
  WebForm = 1,
  Referral = 2,
  Campaign = 3,
  Event = 4,
  ColdOutreach = 5,
  Other = 6,
}

export enum LeadStatus {
  New = 0,
  Contacted = 1,
  Qualified = 2,
  Proposal = 3,
  Won = 4,
  Lost = 5,
}

export enum MailSecurity {
  Auto = 0,
  None = 1,
  StartTls = 2,
  SslOnConnect = 3,
}

export enum ManagementChannel {
  Agent = 0,
  Android = 1,
}

export enum MobileCommandKind {
  Lock = 0,
  Reboot = 1,
  ResetPasscode = 2,
  StartLostMode = 3,
  StopLostMode = 4,
}

export enum MobileMailClient {
  None = 0,
  Outlook = 1,
  GmailExchange = 2,
}

export enum MobileOwnership {
  FullyManaged = 0,
  CompanyOwnedWorkProfile = 1,
  PersonalWorkProfile = 2,
}

export enum MobilePasscodeRequirement {
  None = 0,
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum MobileSystemUpdate {
  Default = 0,
  Automatic = 1,
  Windowed = 2,
  Postpone = 3,
}

export enum MobileWifiSecurity {
  Open = 0,
  Wpa = 1,
}

export enum PayPalEnvironment {
  Sandbox = 0,
  Live = 1,
}

export enum PolicyCheckState {
  Compliant = 0,
  NotCompliant = 1,
  NotSupported = 2,
  Unknown = 3,
}

export enum PolicyEnforcement {
  None = 0,
  Applied = 1,
  Failed = 2,
  InProgress = 3,
  Reverted = 4,
}

export enum PortalInviteKind {
  CustomerJoin = 0,
  Direct = 1,
}

export enum PortalRole {
  Employee = 0,
  PrimaryContact = 1,
}

export enum ProfitLossGrouping {
  Quarter = 0,
  Year = 1,
}

export enum RateKind {
  Standard = 0,
  AfterHours = 1,
  Weekend = 2,
  Manual = 3,
  NonBillable = 4,
}

export enum RecurrenceInterval {
  Monthly = 0,
  Quarterly = 1,
  Yearly = 2,
  Weekly = 3,
}

export enum RemoteDesktopKind {
  Unknown = 0,
  Default = 1,
  Winlogon = 2,
  Secure = 3,
}

export enum RemoteFocusSource {
  None = 0,
  Caret = 1,
  Automation = 2,
}

export enum RemoteInputKind {
  MouseMove = 0,
  MouseDown = 1,
  MouseUp = 2,
  MouseWheel = 3,
  KeyDown = 4,
  KeyUp = 5,
  SecureAttention = 6,
  Text = 7,
}

export enum RemoteMouseButton {
  None = 0,
  Left = 1,
  Right = 2,
  Middle = 3,
}

export enum ServiceAction {
  Start = 0,
  Stop = 1,
  Restart = 2,
  Pause = 3,
  Resume = 4,
}

export enum ServiceFailureAction {
  None = 0,
  Restart = 1,
  Reboot = 2,
  RunCommand = 3,
}

export enum ServiceStartupType {
  Unknown = 0,
  Automatic = 1,
  AutomaticDelayed = 2,
  Manual = 3,
  Disabled = 4,
  Boot = 5,
  System = 6,
}

export enum ServiceState {
  Unknown = 0,
  Stopped = 1,
  StartPending = 2,
  StopPending = 3,
  Running = 4,
  ContinuePending = 5,
  PausePending = 6,
  Paused = 7,
}

export enum SessionState {
  Unknown = 0,
  LoggedOff = 1,
  LoggedOn = 2,
  Locked = 3,
  LoginScreen = 4,
}

export enum ShellKind {
  PowerShell = 0,
  Cmd = 1,
  Sh = 2,
}

export enum SignInFailureReason {
  UnknownAccount = 1,
  WrongPassword = 2,
  LockedOut = 3,
  NotApproved = 4,
  Rejected = 5,
  Disabled = 6,
}

export enum SnmpAuthProtocol {
  None = 0,
  Md5 = 1,
  Sha1 = 2,
}

export enum SnmpPrivProtocol {
  None = 0,
  Des = 1,
  Aes128 = 2,
}

export enum SnmpSecurityLevel {
  NoAuthNoPriv = 0,
  AuthNoPriv = 1,
  AuthPriv = 2,
}

export enum SnmpVersion {
  V2c = 0,
  V3 = 1,
}

export enum SoftwareInstallState {
  Queued = 0,
  Downloading = 1,
  Installing = 2,
  Succeeded = 3,
  Failed = 4,
}

export enum SoftwarePackageSource {
  Upload = 0,
  Url = 1,
}

export enum SynologyPlatform {
  Unknown = 0,
  Dsm = 1,
  Srm = 2,
}

export enum TenantStatus {
  Active = 0,
  Suspended = 1,
}

export enum TicketPriority {
  Low = 0,
  Normal = 1,
  High = 2,
  Urgent = 3,
}

export enum TicketSource {
  Manual = 0,
  Agent = 1,
  Email = 2,
  Recurring = 3,
}

export enum TicketStatus {
  Open = 0,
  InProgress = 1,
  Waiting = 2,
  Resolved = 3,
  Closed = 4,
  WaitingForCustomer = 5,
  WaitingForParts = 6,
  WaitingForVendor = 7,
  Scheduled = 8,
  OnHold = 9,
}

// =====================================================================
//  Wire DTOs.
// =====================================================================

export interface ActivateServerVersionRequest {
  version: string | null;
  restoreDatabase: boolean;
}

export interface AddInvoiceLineRequest {
  description: string;
  notes: string;
  date: string | null;
  quantity: number;
  unitPrice: number;
}

export interface AddLeadActivityRequest {
  kind: LeadActivityKind;
  body: string;
  nextFollowUpUtc: string | null;
  clearFollowUp: boolean;
}

export interface AddSuppressionRequest {
  email: string;
  reason: string | null;
}

export interface AddTicketNoteRequest {
  body: string;
  isInternal: boolean;
  emailCustomer: boolean;
}

export interface AdoptSnmpRequest {
  displayName: string;
  pollSeconds: number;
  credentials: SnmpCredentials;
}

export interface AdoptSnmpResponse {
  monitor: SnmpMonitorDto;
  agentOnline: boolean;
}

export interface AgentCreateTicketRequest {
  title: string;
  description: string;
  priority: TicketPriority;
}

export interface AgentDeviceEvent {
  whenUtc: string;
  kind: DeviceEventKind;
  severity: DeviceEventSeverity;
  summary: string;
  detail: string | null;
  actor: string | null;
  dedupeKey: string | null;
}

export interface AgentDiagnosticDto {
  id: number;
  customerId: number;
  machineName: string;
  agentVersion: string;
  osCaption: string;
  serverUrl: string;
  enrolled: boolean;
  verdict: string;
  checks: DiagnosticCheck[];
  logEntries: DiagnosticLogEntry[];
  collectedUtc: string;
  receivedUtc: string;
  reportedFromIp: string;
}

export interface AgentDiagnosticReport {
  machineName: string | null;
  agentVersion: string | null;
  osCaption: string | null;
  serverUrl: string | null;
  enrolled: boolean;
  verdict: string | null;
  checks: DiagnosticCheck[] | null;
  logEntries: DiagnosticLogEntry[] | null;
  collectedUtc: string;
}

export interface AgentPreflightInfo {
  customer: string;
  serverUrl: string;
}

export interface AgentTicketDto {
  id: number;
  title: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  createdUtc: string;
  updatedUtc: string;
  statusLabel: string;
}

export interface AgentVersionInfo {
  version: string;
}

export interface AndroidAccountDto {
  enabled: boolean;
  projectId: string;
  serviceAccountEmail: string;
  hasServiceAccountKey: boolean;
  topicName: string;
  subscriptionName: string;
  ready: boolean;
  lastSyncUtc: string | null;
  lastSyncError: string | null;
  updatedUtc: string | null;
  updatedBy: string | null;
}

export interface AndroidEnterpriseDto {
  customerId: number;
  connected: boolean;
  enterpriseName: string;
  displayName: string;
  connectedUtc: string | null;
  connectedBy: string | null;
  signupStartedUtc: string | null;
  managedPhones: number;
}

export interface AndroidSetupResult {
  success: boolean;
  message: string;
  topicName: string;
  subscriptionName: string;
}

export interface AndroidSignupDto {
  url: string;
}

export interface AndroidTestRequest {
  settings: UpdateAndroidAccountRequest | null;
}

export interface AndroidTestResult {
  success: boolean;
  message: string;
  managementReachable: boolean;
  subscriptionReachable: boolean;
}

export interface AntivirusProductDto {
  name: string;
  enabled: boolean;
  upToDate: boolean;
}

export interface AppSettingsDto {
  remoteFiles: RemoteFileSettings | null;
  clipboard: ClipboardSettings | null;
  fileExplorer: FileExplorerSettings | null;
  eventLog: EventLogSettings | null;
  liveMetrics: LiveMetricsSettings | null;
  deviceHistory: DeviceHistorySettings | null;
  deploy: DeploySettings | null;
  kbMedia: KbMediaSettings | null;
  synology: SynologySettings | null;
  mail: MailSettings | null;
  signIn: SignInSettings | null;
  audit: AuditSettings | null;
}

export interface AppSettingsResponse {
  settings: AppSettingsDto;
  defaults: AppSettingsDto;
  updatedUtc: string | null;
  updatedBy: string | null;
}

export interface AppVersionInfo {
  version: string;
}

export interface ApproveDeviceRequest {
  employeeIds: number[];
  primaryEmployeeId: number | null;
}

export interface ApprovePortalAccountRequest {
  kbAccess: KbAccessLevel;
  employeeId: number | null;
}

export interface AssignEmployeeRequest {
  employeeId: number;
  isPrimary: boolean;
}

export interface AssignMobilePolicyRequest {
  policyId: number;
}

export interface AssignWindowsPolicyRequest {
  policyId: number | null;
}

export interface AttachmentDto {
  id: number;
  customerId: number;
  ticketId: number | null;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  canView: boolean;
  uploadedByUserId: number;
  uploadedByName: string;
  uploadedUtc: string;
}

export interface AuditEntryDto {
  id: number;
  whenUtc: string;
  actorKind: AuditActorKind;
  actorId: number | null;
  actor: string;
  category: AuditCategory;
  action: string;
  summary: string;
  detail: string | null;
  target: string | null;
  targetName: string | null;
  customerId: number | null;
  outcome: AuditOutcome;
  statusCode: number;
  method: string;
  path: string;
  ipAddress: string;
  userAgent: string;
  durationMs: number;
}

export interface AuditPageDto {
  entries: AuditEntryDto[];
  hasMore: boolean;
  totalMatching: number;
  totalStored: number;
}

export interface AuditQuery {
  actorKind: AuditActorKind | null;
  actor: string | null;
  category: AuditCategory | null;
  outcome: AuditOutcome | null;
  search: string | null;
  target: string | null;
  customerId: number | null;
  fromUtc: string | null;
  toUtc: string | null;
  beforeId: number | null;
  limit: number;
}

export interface AuditSettings {
  retentionDays: number;
  maxStoredEntries: number;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresInSeconds: number;
  user: UserDto;
}

export interface AutoBillRunResult {
  customerId: number;
  invoice: InvoiceDto | null;
  customerEmailed: boolean;
  adminsEmailed: boolean;
  message: string;
}

export interface AutoBillingDto {
  customerId: number;
  enabled: boolean;
  dayOfMonth: number;
  nextRunUtc: string | null;
  lastRunUtc: string | null;
  lastResult: string;
  adminRecipients: string[];
}

export interface BackupConfigDto {
  enabled: boolean;
  frequency: BackupFrequency;
  hourLocal: number;
  dayOfWeek: DayOfWeek;
  destinationPath: string;
  username: string;
  hasPassword: boolean;
  keepCount: number;
  keepDays: number;
  includeMedia: boolean;
  notifyEmail: string;
  updatedUtc: string | null;
  updatedBy: string | null;
  lastRunUtc: string | null;
  lastRunSucceeded: boolean;
  lastRunError: string | null;
  lastSuccessUtc: string | null;
  nextDueUtc: string | null;
  notifiesOnFailure: boolean;
  isConfigured: boolean;
  runsOnSchedule: boolean;
}

export interface BackupDto {
  fileName: string;
  sizeBytes: number;
  createdUtc: string;
  trigger: BackupTrigger;
}

export interface BackupManifest {
  schemaVersion: number;
  createdUtc: string;
  trigger: BackupTrigger;
  createdBy: string | null;
  appVersion: string;
  machineName: string;
  databaseBytes: number;
  mediaFileCount: number;
  includesKeyRing: boolean;
  tenantId: number | null;
  tenantName: string | null;
}

export interface BackupRunDto {
  startedUtc: string;
  finishedUtc: string | null;
  trigger: BackupTrigger;
  success: boolean;
  fileName: string | null;
  sizeBytes: number;
  error: string | null;
  actor: string | null;
}

export interface BackupStatusDto {
  config: BackupConfigDto;
  backups: BackupDto[];
  recentRuns: BackupRunDto[];
  destinationFreeBytes: number | null;
  destinationError: string | null;
  notificationsDeliverable: boolean;
  restorePending: boolean;
}

export interface BackupTestResult {
  success: boolean;
  summary: string;
  exists: boolean;
  writable: boolean;
  freeBytes: number | null;
  detail: string | null;
}

export interface BatteryDto {
  name: string;
  manufacturer: string;
  serialNumber: string;
  chemistry: string;
  designCapacityMilliwattHours: number;
  fullChargeCapacityMilliwattHours: number;
  cycleCount: number;
}

export interface BillingConfigDto {
  customerId: number;
  standardRate: number;
  afterHoursMultiplier: number;
  weekendMultiplier: number;
  afterHoursStartHour: number;
  afterHoursEndHour: number;
  billingIncrementMinutes: number;
  minimumMinutes: number;
  taxPercent: number;
  purchaseMarkupPercent: number;
}

export interface BillingReportDto {
  invoicedTotal: number;
  paidTotal: number;
  outstandingTotal: number;
  unbilledValue: number;
  draftCount: number;
  issuedCount: number;
  paidCount: number;
  voidCount: number;
  byCustomer: CustomerRevenueRow[];
}

export interface BiosDto {
  vendor: string;
  version: string;
  releaseDateUtc: string | null;
}

export interface BitLockerKeyDto {
  drive: string;
  protectorId: string;
  escrowedUtc: string;
}

export interface BitLockerKeyEscrow {
  drive: string;
  protectorId: string;
  recoveryPassword: string;
}

export interface BitLockerKeyRevealDto {
  drive: string;
  protectorId: string;
  recoveryPassword: string;
}

export interface BulkServiceControlRequest {
  deviceIds: number[];
  name: string;
  action: ServiceAction;
  stopDependents: boolean;
}

export interface BulkServiceControlResult {
  outcomes: BulkServiceOutcome[];
}

export interface BulkServiceOutcome {
  deviceId: number;
  deviceName: string;
  success: boolean;
  changed: boolean;
  error: string | null;
  warning: string | null;
}

export interface CampaignAudienceDto {
  includeLeads: boolean;
  leadStatuses: LeadStatus[] | null;
  leadTag: string | null;
  includeCustomerContacts: boolean;
  includeEmployees: boolean;
  customerIds: number[] | null;
}

export interface CampaignDetailDto {
  campaign: CampaignDto;
  recipients: CampaignRecipientDto[];
}

export interface CampaignDto {
  id: number;
  name: string;
  subject: string;
  body: string;
  audience: CampaignAudienceDto;
  status: CampaignStatus;
  statusLabel: string;
  createdUtc: string;
  createdBy: string;
  updatedUtc: string;
  startedUtc: string | null;
  finishedUtc: string | null;
  startedBy: string;
  recipients: number;
  sent: number;
  failed: number;
  skipped: number;
  pending: number;
  unsubscribes: number;
  leadsCreated: number;
  leadsWon: number;
}

export interface CampaignPreviewDto {
  recipients: number;
  suppressed: number;
  sample: CampaignPreviewRecipientDto[];
  renderedSubject: string;
  renderedBody: string;
  blocked: string | null;
  warning: string | null;
}

export interface CampaignPreviewRecipientDto {
  email: string;
  name: string;
  kindLabel: string;
}

export interface CampaignRecipientDto {
  id: number;
  email: string;
  name: string;
  kind: CampaignRecipientKind;
  kindLabel: string;
  leadId: number | null;
  customerId: number | null;
  outcome: CampaignRecipientOutcome;
  outcomeLabel: string;
  error: string;
  sentUtc: string | null;
  unsubscribed: boolean;
}

export interface CatalogCustomerRow {
  customerId: number;
  customerName: string;
  chargeCount: number;
  cost: number;
  revenue: number;
  margin: number;
}

export interface CatalogIdleItemRow {
  itemId: number;
  sku: string;
  name: string;
  kind: CatalogItemKind;
  kindName: string;
  unitCost: number;
  listPrice: number | null;
  lastChargedUtc: string | null;
}

export interface CatalogItemDto {
  id: number;
  sku: string;
  name: string;
  description: string;
  kind: CatalogItemKind;
  unitCost: number;
  listPrice: number | null;
  vendor: string;
  active: boolean;
  createdUtc: string;
  updatedUtc: string;
}

export interface CatalogItemSalesRow {
  itemId: number;
  sku: string;
  name: string;
  kind: CatalogItemKind;
  kindName: string;
  active: boolean;
  chargeCount: number;
  quantity: number;
  cost: number;
  revenue: number;
  margin: number;
  marginPercent: number;
  customerCount: number;
  firstChargedUtc: string;
  lastChargedUtc: string;
}

export interface CatalogKindRow {
  kind: CatalogItemKind;
  kindName: string;
  itemCount: number;
  chargeCount: number;
  revenue: number;
  margin: number;
}

export interface CatalogPriceQuote {
  catalogItemId: number;
  name: string;
  unitCost: number;
  unitPrice: number;
  source: CatalogPriceSource;
  explanation: string;
}

export interface CatalogReportDto {
  totalItems: number;
  activeItems: number;
  retiredItems: number;
  contractPrices: number;
  chargeCount: number;
  quantity: number;
  costTotal: number;
  revenueTotal: number;
  marginTotal: number;
  marginPercent: number;
  absorbedCost: number;
  offCatalogCharges: number;
  offCatalogCost: number;
  offCatalogRevenue: number;
  byKind: CatalogKindRow[];
  byItem: CatalogItemSalesRow[];
  byCustomer: CatalogCustomerRow[];
  notCharged: CatalogIdleItemRow[];
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ClipboardFileInfo {
  name: string;
  size: number;
}

export interface ClipboardFiles {
  deviceId: number;
  transferId: string;
  files: ClipboardFileInfo[];
  pasteAfterSet: boolean;
}

export interface ClipboardPayload {
  deviceId: number;
  text: string;
  pasteAfterSet: boolean;
  capturedUtc: string;
}

export interface ClipboardSettings {
  maxChars: number;
}

export interface ConvertLeadRequest {
  defaultRate: number;
  billingTerms: string;
  addContactAsEmployee: boolean;
}

export interface ConvertLeadResult {
  lead: LeadDto;
  customerId: number;
}

export interface CpuDetailDto {
  manufacturer: string;
  socket: string;
  sockets: number;
  maxClockMhz: number;
  l2CacheBytes: number;
  l3CacheBytes: number;
}

export interface CreateCatalogItemRequest {
  sku: string;
  name: string;
  description: string;
  kind: CatalogItemKind;
  unitCost: number;
  listPrice: number | null;
  vendor: string;
  active: boolean;
}

export interface CreateCustomerRequest {
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  billingTerms: string;
  defaultRate: number;
}

export interface CreateDeviceRequest {
  customerId: number;
  siteId: number | null;
  name: string;
}

export interface CreateEmployeeRequest {
  customerId: number;
  fullName: string;
  email: string;
  phone: string;
  title: string;
}

export interface CreateEnrollTokenRequest {
  customerId: number;
  siteId: number | null;
  validHours: number;
  reusable: boolean;
}

export interface CreateExpenseRequest {
  incurredUtc: string;
  paidUtc: string | null;
  category: ExpenseCategory;
  description: string;
  vendor: string;
  amount: number;
  customerId: number | null;
  directCost: boolean;
  notes: string;
}

export interface CreateForumThreadRequest {
  categoryId: number;
  title: string;
  body: string;
}

export interface CreateHostUserRequest {
  email: string | null;
  displayName: string | null;
  password: string | null;
  permissions: HostPermission | null;
  allOrganizations: boolean | null;
  organizations: HostTenantAssignment[] | null;
}

export interface CreateLeadRequest {
  company: string;
  contactName: string;
  email: string;
  phone: string;
  website: string;
  address: string;
  source: LeadSource;
  sourceDetail: string;
  estimatedMonthlyValue: number;
  ownerUserId: number | null;
  tags: string[] | null;
  nextFollowUpUtc: string | null;
  notes: string;
}

export interface CreateLocalUserRequest {
  userName: string;
  fullName: string | null;
  description: string | null;
  password: string;
  administrator: boolean;
  remoteDesktop: boolean;
  mustChangePassword: boolean;
  passwordNeverExpires: boolean;
}

export interface CreateLocalUserResult {
  success: boolean;
  error: string | null;
  user: LocalUserDto | null;
}

export interface CreatePortalInviteRequest {
  kind: PortalInviteKind;
  email: string;
  grantsRole: PortalRole;
  validDays: number;
}

export interface CreatePurchaseRequest {
  customerId: number;
  ticketId: number;
  description: string;
  quantity: number;
  unitCost: number;
  billable: boolean;
  purchaseDateUtc: string;
  catalogItemId: number | null;
  unitPrice: number | null;
}

export interface CreateRecurringExpenseRequest {
  category: ExpenseCategory;
  description: string;
  vendor: string;
  amount: number;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  directCost: boolean;
  customerId: number | null;
  autoMarkPaid: boolean;
  notes: string;
}

export interface CreateSiteRequest {
  customerId: number;
  name: string;
  address: string;
  subnet: string;
}

export interface CreateSoftwarePackageRequest {
  name: string | null;
  version: string | null;
  publisher: string | null;
  notes: string | null;
  source: SoftwarePackageSource;
  downloadUrl: string | null;
  fileName: string | null;
  sha256: string | null;
  arguments: string | null;
  successExitCodes: string | null;
  timeoutMinutes: number;
}

export interface CreateStaffUserRequest {
  email: string | null;
  displayName: string | null;
  role: string | null;
  password: string | null;
  mustChangePassword: boolean;
}

export interface CreateTenantRequest {
  name: string | null;
  slug: string | null;
  adminEmail: string | null;
  adminName: string | null;
  adminPassword: string | null;
  notes: string | null;
}

export interface CreateTicketRequest {
  customerId: number;
  deviceId: number | null;
  title: string;
  description: string;
  priority: TicketPriority;
  reporterEmployeeId: number | null;
}

export interface CreateTimeEntryRequest {
  customerId: number;
  ticketId: number;
  startUtc: string;
  endUtc: string | null;
  minutes: number;
  rate: number;
  billable: boolean;
  notes: string;
}

export interface CurrentTenantDto {
  id: number;
  name: string;
  enteredByHost: boolean;
}

export interface CustomerCatalogPriceDto {
  customerId: number;
  catalogItemId: number;
  sku: string;
  itemName: string;
  standardUnitPrice: number;
  unitPrice: number;
  updatedUtc: string;
}

export interface CustomerDeviceRow {
  customerId: number;
  customerName: string;
  deviceCount: number;
  onlineCount: number;
}

export interface CustomerDto {
  id: number;
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  billingTerms: string;
  defaultRate: number;
  employeeCount: number;
  deviceCount: number;
  openTicketCount: number;
  archived: boolean;
  archivedUtc: string | null;
}

export interface CustomerRevenueRow {
  customerId: number;
  customerName: string;
  invoiced: number;
  paid: number;
  outstanding: number;
  unbilled: number;
}

export interface CustomerTicketRow {
  customerId: number;
  customerName: string;
  openCount: number;
  totalCount: number;
}

export interface CustomerTimeRow {
  customerId: number;
  customerName: string;
  billableMinutes: number;
  billableValue: number;
}

export interface DeleteLocalUserRequest {
  userName: string;
  confirmName: string | null;
  deleteProfile: boolean;
}

export interface DeleteLocalUserResult {
  success: boolean;
  error: string | null;
  profileDeleted: boolean;
  profileError: string | null;
}

export interface DeleteTenantRequest {
  confirmName: string | null;
}

export interface DeployAgentCommand {
  targetIp: string;
  targetHostname: string;
  adminUsername: string;
  adminPassword: string;
  enrollToken: string;
  serverUrl: string;
  deploymentId: number;
}

export interface DeployAgentRequest {
  discoveredDeviceId: number;
  adminUsername: string;
  adminPassword: string;
}

export interface DeployAgentResult {
  success: boolean;
  stage: string;
  message: string;
}

export interface DeployLogDto {
  id: number;
  customerId: number;
  targetIp: string;
  targetHostname: string;
  initiatedByUser: string;
  success: boolean;
  stage: string;
  message: string;
  whenUtc: string;
}

export interface DeployProgressReport {
  deploymentId: number;
  stage: string;
  success: boolean;
  message: string;
}

export interface DeploySettings {
  maxMessageLength: number;
  maxStageLength: number;
  reportGraceMinutes: number;
}

export interface DesktopThumbnail {
  deviceId: number;
  width: number;
  height: number;
  jpeg: string;
  desktop: RemoteDesktopKind;
  capturedUtc: string;
}

export interface DeviceDto {
  id: number;
  customerId: number;
  siteId: number | null;
  name: string;
  primaryEmployeeId: number | null;
  primaryEmployeeName: string | null;
  assignedEmployeeIds: number[];
  hardware: HardwareInfoDto | null;
  os: OsInfoDto | null;
  agentVersion: string | null;
  enrolledUtc: string;
  lastInventoryUtc: string | null;
  presence: DevicePresenceDto;
  status: ApprovalStatus;
  archived: boolean;
  uninstallRequested: boolean;
  uninstallCompleted: boolean;
  maintenanceUntilUtc: string | null;
  stoppedServices: number;
  channel: ManagementChannel;
  mobile: MobileInfoDto | null;
  windowsPolicyId: number | null;
  windowsPolicyName: string | null;
  policyIssues: number;
  lock: DeviceLockDto | null;
  lastSeenUtc: string | null;
  lastLoggedOnUser: string | null;
  lastLoggedOnUtc: string | null;
}

export interface DeviceEventDto {
  id: number;
  deviceId: number;
  whenUtc: string;
  kind: DeviceEventKind;
  severity: DeviceEventSeverity;
  summary: string;
  detail: string | null;
  actor: string | null;
  source: DeviceEventSource;
}

export interface DeviceEventReport {
  events: AgentDeviceEvent[];
}

export interface DeviceHistoryPage {
  events: DeviceEventDto[];
  hasMore: boolean;
}

export interface DeviceHistoryQuery {
  category: DeviceEventCategory | null;
  search: string | null;
  beforeId: number | null;
  limit: number;
}

export interface DeviceHistorySettings {
  maxPageSize: number;
  defaultPageSize: number;
  maxEventsPerReport: number;
  maxSummaryChars: number;
  maxDetailChars: number;
  maxActorChars: number;
  maxStoredPerDevice: number;
  retentionDays: number;
  maxDiffEvents: number;
}

export interface DeviceLockDto {
  lockId: string;
  message: string | null;
  lockedBy: string;
  lockedUtc: string;
  appliedUtc: string | null;
  lastError: string | null;
}

export interface DeviceLockReport {
  lockId: string | null;
  holding: boolean;
  error: string | null;
}

export interface DeviceLockSpec {
  lockId: string;
  message: string | null;
  lockedUtc: string;
}

export interface DevicePresenceDto {
  deviceId: number;
  isOnline: boolean;
  loggedOnUser: string | null;
  sessionState: SessionState;
  lastSeenUtc: string | null;
}

export interface DeviceReportDto {
  totalManaged: number;
  online: number;
  offline: number;
  pendingApproval: number;
  archived: number;
  monitors: number;
  byOs: OsBreakdownRow[];
  byCustomer: CustomerDeviceRow[];
}

export interface DeviceServiceDto {
  name: string;
  displayName: string;
  description: string | null;
  state: ServiceState;
  startupType: ServiceStartupType;
  account: string | null;
  processId: number | null;
  acceptsStop: boolean;
  binaryPath: string | null;
  runningDependents: string[];
  dependencies: string[];
  locked: boolean;
  lockedReason: string | null;
  acceptsPause: boolean;
  exitCode: number;
  attention: string | null;
  recovery: ServiceRecoveryDto | null;
}

export interface DeviceServiceListResult {
  success: boolean;
  error: string | null;
  machineName: string;
  services: DeviceServiceDto[];
}

export interface DeviceValidateRequest {
  deviceId: number;
  deviceKey: string;
}

export interface DeviceValidateResponse {
  valid: boolean;
}

export interface DeviceWindowsPolicyDto {
  policyId: number | null;
  policyName: string | null;
  compliance: WindowsComplianceDto | null;
  stale: boolean;
}

export interface DiagnosticCheck {
  name: string | null;
  status: DiagnosticStatus;
  detail: string | null;
}

export interface DiagnosticLogEntry {
  whenUtc: string;
  level: string | null;
  message: string | null;
}

export interface DiscoveredDeviceDto {
  id: number;
  customerId: number;
  siteId: number | null;
  ipAddress: string;
  macAddress: string;
  hostname: string;
  openPorts: number[];
  isManaged: boolean;
  managedDeviceId: number | null;
  discoveredByDeviceId: number;
  firstSeenUtc: string;
  lastSeenUtc: string;
  kind: DiscoveredDeviceKind;
  snmpEnabled: boolean;
  snmpSysName: string;
  snmpDescription: string;
  snmpContact: string;
  snmpLocation: string;
  adoptedMonitorId: number | null;
  snmpCommunity: string;
  supportsPushInstall: boolean;
}

export interface DiscoveredHost {
  ipAddress: string;
  macAddress: string;
  hostname: string;
  openPorts: number[];
  snmp: SnmpInfo | null;
}

export interface DiscoveryReport {
  scannedSubnets: string[];
  hosts: DiscoveredHost[];
  completedUtc: string;
}

export interface DiskDto {
  model: string;
  sizeBytes: number;
  mediaType: string;
  serialNumber: string;
}

export interface DisplayDto {
  id: string;
  label: string;
  x: number;
  y: number;
  width: number;
  height: number;
  primary: boolean;
}

export interface DisplayLayout {
  deviceId: number;
  displays: DisplayDto[];
  selectedId: string | null;
}

export interface EditForumPostRequest {
  body: string;
}

export interface EmailInvoiceRequest {
  to: string | null;
  cc: string | null;
  subject: string | null;
  body: string | null;
  attachPdf: boolean;
  markIssued: boolean;
}

export interface EmailInvoiceResult {
  success: boolean;
  message: string;
  sent: InvoiceEmailDto | null;
  invoice: InvoiceDto | null;
}

export interface EmployeeDto {
  id: number;
  customerId: number;
  fullName: string;
  email: string;
  phone: string;
  title: string;
  deviceCount: number;
}

export interface EnrollInfoDto {
  token: string;
  serverUrl: string;
  downloadUrl: string;
  installCommand: string;
}

export interface EnrollRequest {
  token: string;
  machineName: string;
  deviceName: string | null;
  hardware: HardwareInfoDto;
  os: OsInfoDto;
  agentVersion: string;
}

export interface EnrollResponse {
  deviceId: number;
  deviceKey: string;
  hubUrl: string;
}

export interface EnrollSynologyRequest {
  displayName: string;
  platform: SynologyPlatform;
  pollSeconds: number;
  inventorySeconds: number;
  snmp: SnmpCredentials;
  api: SynologyCredentials;
  discoveredDeviceId: number | null;
  ipAddress: string;
  pollingDeviceId: number | null;
}

export interface EnrollTokenDto {
  token: string;
  customerId: number;
  siteId: number | null;
  expiresUtc: string;
  used: boolean;
}

export interface EnterTenantResponse {
  accessToken: string;
  expiresInSeconds: number;
  user: UserDto;
  tenant: TenantDto;
}

export interface EventLogEntryDto {
  eventId: number;
  level: number;
  levelName: string;
  provider: string;
  timeUtc: string | null;
  message: string;
}

export interface EventLogQueryRequest {
  logName: string;
  level: number | null;
  eventId: number | null;
  search: string | null;
  fromUtc: string | null;
  toUtc: string | null;
  maxEvents: number;
}

export interface EventLogQueryResult {
  success: boolean;
  error: string | null;
  logName: string;
  entries: EventLogEntryDto[];
  truncated: boolean;
  scanTruncated: boolean;
}

export interface EventLogSettings {
  maxEvents: number;
  maxScan: number;
  maxMessageChars: number;
  queryTimeoutSeconds: number;
}

export interface ExpenseDto {
  id: number;
  incurredUtc: string;
  paidUtc: string | null;
  category: ExpenseCategory;
  categoryName: string;
  description: string;
  vendor: string;
  amount: number;
  customerId: number | null;
  customerName: string;
  directCost: boolean;
  recurringId: number | null;
  notes: string;
  createdUtc: string;
  createdBy: string;
  isPaid: boolean;
}

export interface ExpenseListDto {
  expenses: ExpenseDto[];
  total: number;
  paidTotal: number;
  unpaidTotal: number;
  count: number;
}

export interface FetchFileCommand {
  transferId: string;
  path: string;
}

export interface FileBrowseRequest {
  path: string | null;
}

export interface FileBrowseResult {
  success: boolean;
  error: string | null;
  path: string;
  parentPath: string | null;
  entries: FileEntryDto[];
  truncated: boolean;
  directoriesTruncated: boolean;
}

export interface FileEntryDto {
  name: string;
  path: string;
  isDirectory: boolean;
  sizeBytes: number;
  modifiedUtc: string | null;
  detail: string | null;
}

export interface FileExplorerSettings {
  maxEntries: number;
  browseTimeoutSeconds: number;
  transferTimeoutSeconds: number;
}

export interface FileOperationCommand {
  kind: FileOperationKind;
  path: string;
  name: string | null;
}

export interface FileOperationResult {
  success: boolean;
  error: string | null;
}

export interface ForumCapabilitiesDto {
  isStaff: boolean;
  isAdmin: boolean;
  displayName: string;
  customerId: number | null;
  customerName: string | null;
  mediaMaxBytes: number;
  mediaMaxPerPost: number;
}

export interface ForumCategoryDto {
  id: number;
  slug: string;
  name: string;
  description: string;
  sortOrder: number;
  staffOnly: boolean;
  threadCount: number;
  postCount: number;
  lastActivityUtc: string | null;
}

export interface ForumMediaDto {
  id: number;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  url: string;
  postId: number | null;
  uploadedUtc: string;
  uploadedBy: string;
}

export interface ForumPostDto {
  id: number;
  threadId: number;
  authorKind: ForumAuthorKind;
  authorName: string;
  customerName: string | null;
  body: string;
  createdUtc: string;
  editedUtc: string | null;
  editedByName: string | null;
  deletion: ForumPostDeletion;
  deletedByName: string | null;
  isOriginalPost: boolean;
  isAccepted: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface ForumPostPageDto {
  posts: ForumPostDto[];
  totalCount: number;
  hasMore: boolean;
}

export interface ForumReplyRequest {
  body: string;
}

export interface ForumThreadDto {
  summary: ForumThreadSummaryDto;
  canReply: boolean;
  canModerate: boolean;
  canMarkAccepted: boolean;
}

export interface ForumThreadPageDto {
  threads: ForumThreadSummaryDto[];
  totalCount: number;
  hasMore: boolean;
}

export interface ForumThreadSummaryDto {
  id: number;
  title: string;
  categoryId: number;
  categoryName: string;
  authorKind: ForumAuthorKind;
  authorName: string;
  customerName: string | null;
  createdUtc: string;
  lastActivityUtc: string;
  lastPosterName: string;
  replyCount: number;
  isPinned: boolean;
  isLocked: boolean;
  acceptedPostId: number | null;
  isDeleted: boolean;
}

export interface GpuDto {
  name: string;
  vendor: string;
  memoryBytes: number;
  driverVersion: string;
  driverDateUtc: string | null;
  videoProcessor: string;
  currentMode: string;
}

export interface HardwareInfoDto {
  manufacturer: string;
  model: string;
  serialNumber: string;
  biosVersion: string;
  cpuName: string;
  cpuCores: number;
  cpuLogical: number;
  ramBytes: number;
  disks: DiskDto[];
  nics: NicDto[];
  gpus: GpuDto[] | null;
  memoryModules: MemoryModuleDto[] | null;
  memorySlotsTotal: number;
  memorySlotsUsed: number;
  motherboard: MotherboardDto | null;
  bios: BiosDto | null;
  cpu: CpuDetailDto | null;
  chassisType: string | null;
  systemFamily: string | null;
  systemSku: string | null;
  monitors: MonitorDto[] | null;
  batteries: BatteryDto[] | null;
  tpm: TpmDto | null;
}

export interface HeartbeatReport {
  loggedOnUser: string | null;
  sessionState: SessionState;
  timestampUtc: string;
}

export interface HostBillNowRequest {
  send: boolean;
}

export interface HostBillingRunResultDto {
  raised: number;
  emailed: number;
  emailFailed: number;
  skipped: number;
  lines: string[];
}

export interface HostBillingSettingsDto {
  enabled: boolean;
  billingDay: number;
  dueDays: number;
  taxPercent: number;
  reminderDays: number;
  invoicePrefix: string;
  issuerName: string;
  issuerAddress: string;
  issuerEmail: string;
  currency: string;
  footerNote: string;
  nextRunUtc: string | null;
  lastRunUtc: string | null;
  lastRunSummary: string | null;
  updatedUtc: string | null;
  updatedBy: string | null;
  trialDays: number;
  trialForNewOrganizations: boolean;
}

export interface HostDashboardDto {
  generatedUtc: string;
  server: HostServerDto;
  tenants: HostTenantHealthDto[];
  recentEvents: HostEventDto[];
}

export interface HostEventDto {
  id: number;
  whenUtc: string;
  actor: string;
  summary: string;
  detail: string | null;
}

export interface HostInvoiceDto {
  id: number;
  number: string;
  tenantId: number;
  tenantName: string;
  billToName: string;
  billToEmail: string;
  billToAddress: string;
  period: string;
  periodLabel: string;
  status: InvoiceStatus;
  isOverdue: boolean;
  createdUtc: string;
  issuedUtc: string | null;
  dueUtc: string | null;
  paidUtc: string | null;
  paidNote: string | null;
  lines: HostInvoiceLineDto[];
  subtotal: number;
  taxPercent: number;
  taxAmount: number;
  total: number;
  currency: string;
  automatic: boolean;
  createdBy: string;
  payUrl: string;
  emails: HostInvoiceEmailDto[];
  payments: InvoicePaymentDto[];
  interval: HostBillingInterval;
  periodEndUtc: string | null;
}

export interface HostInvoiceEmailDto {
  whenUtc: string;
  kind: HostInvoiceEmailKind;
  to: string;
  success: boolean;
  error: string;
  actor: string;
}

export interface HostInvoiceLineDto {
  description: string;
  quantity: number;
  unitPrice: number;
  amount: number;
}

export interface HostInvoiceListDto {
  invoices: HostInvoiceDto[];
  summary: HostInvoiceSummaryDto;
}

export interface HostInvoiceSummaryDto {
  outstandingTotal: number;
  outstandingCount: number;
  overdueTotal: number;
  overdueCount: number;
  paidThisYear: number;
  drafts: number;
}

export interface HostMailTestRequest {
  settings: UpdateMailAccountRequest | null;
  sendTestTo: string | null;
}

export interface HostMarkPaidRequest {
  note: string | null;
  sendReceipt: boolean;
}

export interface HostServerDto {
  version: string;
  environment: string;
  machineName: string;
  operatingSystem: string;
  startedUtc: string;
  workingSetBytes: number;
  dataBytes: number;
  diskFreeBytes: number | null;
  diskTotalBytes: number | null;
  updatesManaged: boolean;
  latestVersion: string | null;
  updateAvailable: boolean;
  lastUpdateCheckUtc: string | null;
  lastUpdateFailure: string | null;
  hostOperators: number;
}

export interface HostTenantAccessDto {
  tenantId: number;
  tenantName: string;
  administrator: boolean;
}

export interface HostTenantAssignment {
  tenantId: number;
  administrator: boolean;
}

export interface HostTenantBackupDto {
  tenantId: number;
  tenantName: string;
  running: boolean;
  canManage: boolean;
  config: BackupConfigDto;
  restorePending: boolean;
}

export interface HostTenantBillingDto {
  tenantId: number;
  tenantName: string;
  enabled: boolean;
  planName: string;
  baseMonthly: number;
  perDevice: number;
  includedDevices: number;
  perStaff: number;
  includedStaff: number;
  taxPercent: number | null;
  billingName: string;
  billingEmail: string;
  billingAddress: string;
  notes: string;
  lastBilledPeriod: string | null;
  managedDevices: number | null;
  staffAccounts: number | null;
  estimatedMonthly: number | null;
  outstandingTotal: number;
  overdueInvoices: number;
  interval: HostBillingInterval;
  nextPeriod: string | null;
  nextPeriodLabel: string | null;
  billedThroughUtc: string | null;
  paidThroughUtc: string | null;
  terminatedUtc: string | null;
  terminatedBy: string | null;
  serviceEndsUtc: string | null;
  serviceEnded: boolean;
  trialStartedUtc: string | null;
  trialEndsUtc: string | null;
  inTrial: boolean;
  trialExpired: boolean;
}

export interface HostTenantHealthDto {
  id: number;
  name: string;
  status: TenantStatus;
  isDefault: boolean;
  running: boolean;
  startError: string | null;
  databaseBytes: number;
  customers: number | null;
  devices: number | null;
  agentsOnline: number | null;
  pendingDevices: number | null;
  staffUsers: number | null;
  openTickets: number | null;
  urgentTickets: number | null;
  outstandingTotal: number | null;
  overdueInvoices: number | null;
  overdueTotal: number | null;
  lockedAccounts: number | null;
  backupsScheduled: boolean;
  lastBackupUtc: string | null;
  lastBackupSucceeded: boolean | null;
  lastBackupError: string | null;
  lastSuccessfulBackupUtc: string | null;
}

export interface HostUserDto {
  id: number;
  email: string;
  displayName: string;
  createdUtc: string;
  mustChangePassword: boolean;
  disabled: boolean;
  permissions: HostPermission;
  allOrganizations: boolean;
  organizations: HostTenantAccessDto[] | null;
  lastSignInUtc: string | null;
}

export interface InboundMailDto {
  id: number;
  receivedUtc: string;
  fromAddress: string;
  fromName: string;
  subject: string;
  body: string;
  kind: InboundMailKind;
  invoiceId: number | null;
  customerId: number | null;
  ticketId: number | null;
  note: string;
}

export interface InstallServerVersionRequest {
  version: string | null;
  activate: boolean;
}

export interface InstallSoftwareCommand {
  jobId: number;
  packageName: string;
  packageVersion: string;
  downloadUrl: string;
  fileName: string;
  sha256: string;
  sizeBytes: number;
  arguments: string;
  successExitCodes: number[];
  timeoutMinutes: number;
}

export interface InstallSoftwareRequest {
  deviceIds: number[] | null;
}

export interface InstallSoftwareResponse {
  jobs: SoftwareInstallJobDto[];
  skipped: string[];
}

export interface InstallUpdatesRequest {
  updateId: string | null;
}

export interface InstalledPatchDto {
  hotFixId: string;
  description: string;
  installedUtc: string | null;
}

export interface InstalledSoftwareDto {
  key: string;
  name: string;
  version: string;
  publisher: string;
  installedUtc: string | null;
  sizeBytes: number | null;
  canUninstall: boolean;
}

export interface InventoryReport {
  hardware: HardwareInfoDto;
  os: OsInfoDto;
  agentVersion: string;
}

export interface InvoiceDto {
  id: number;
  customerId: number;
  customerName: string;
  number: string;
  status: InvoiceStatus;
  createdUtc: string;
  issuedUtc: string | null;
  dueUtc: string | null;
  paidUtc: string | null;
  lines: InvoiceLineDto[];
  subtotal: number;
  taxPercent: number;
  taxAmount: number;
  total: number;
  customerDeleted: boolean;
  recurringId: number | null;
  isOverdue: boolean;
  statusLabel: string;
  isDraft: boolean;
  isIssued: boolean;
  isRecurring: boolean;
}

export interface InvoiceEmailDraftDto {
  invoiceId: number;
  invoiceNumber: string;
  to: string;
  subject: string;
  body: string;
  suggestions: InvoiceRecipientDto[];
  canSend: boolean;
  blocked: string | null;
}

export interface InvoiceEmailDto {
  id: number;
  invoiceId: number;
  sentUtc: string;
  to: string;
  cc: string;
  subject: string;
  sentByName: string;
  success: boolean;
  error: string;
  bounced: boolean;
  bounceDetail: string;
  bouncedUtc: string | null;
  replyCount: number;
}

export interface InvoiceLineDto {
  id: number;
  description: string;
  notes: string;
  date: string | null;
  quantity: number;
  unitPrice: number;
  amount: number;
  kind: string;
  sourceId: number | null;
  ticketId: number | null;
  ticketTitle: string;
  ticketHeading: string;
}

export interface InvoiceListDto {
  invoices: InvoiceDto[];
  count: number;
  filteredTotal: number;
  summary: InvoiceSummaryDto;
}

export interface InvoicePaymentDto {
  id: number;
  invoiceId: number;
  provider: string;
  orderId: string;
  captureId: string;
  amount: number;
  currency: string;
  status: InvoicePaymentStatus;
  payerEmail: string;
  payerName: string;
  error: string;
  createdUtc: string;
  completedUtc: string | null;
  sandbox: boolean;
}

export interface InvoicePaymentsDto {
  payUrl: string;
  available: boolean;
  blocked: string | null;
  warning: string | null;
  payments: InvoicePaymentDto[];
}

export interface InvoiceRecipientDto {
  email: string;
  name: string;
  source: string;
}

export interface InvoiceSummaryDto {
  totalCount: number;
  draftCount: number;
  draftTotal: number;
  outstandingCount: number;
  outstandingTotal: number;
  overdueCount: number;
  overdueTotal: number;
  paidCount: number;
  paidTotal: number;
  voidCount: number;
}

export interface InvoiceVersionDto {
  version: number;
  atUtc: string;
  byUserName: string;
  change: string;
  snapshot: InvoiceDto;
}

export interface IssueInvoiceRequest {
  dueUtc: string | null;
}

export interface KbArticleDto {
  summary: KbArticleSummaryDto;
  body: string;
  revision: number;
  updatedBy: string;
  canEdit: boolean;
}

export interface KbArticleSummaryDto {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  categoryId: number | null;
  categoryName: string | null;
  tags: string[];
  visibility: KbVisibility;
  status: KbArticleStatus;
  customerId: number | null;
  customerName: string | null;
  authorName: string;
  createdUtc: string;
  updatedUtc: string;
  publishedUtc: string | null;
  viewCount: number;
}

export interface KbCapabilitiesDto {
  isStaff: boolean;
  isAdmin: boolean;
  isPrimaryContact: boolean;
  customerId: number | null;
  customerName: string | null;
  displayName: string;
  access: KbAccessLevel;
  canWrite: boolean;
  allowedVisibilities: KbVisibility[];
  mediaMaxBytes: number;
  mediaMaxPerArticle: number;
}

export interface KbCategoryDto {
  id: number;
  slug: string;
  name: string;
  description: string;
  sortOrder: number;
  customerId: number | null;
  articleCount: number;
}

export interface KbCustomerAccessDto {
  customerId: number;
  customerName: string;
  access: KbAccessLevel;
  grantedUtc: string | null;
  grantedBy: string | null;
  accountCount: number;
  writerCount: number;
}

export interface KbMediaDto {
  id: number;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  url: string;
  articleId: number | null;
  uploadedUtc: string;
  uploadedBy: string;
}

export interface KbMediaSettings {
  maxBytes: number;
  maxPerArticle: number;
  maxFileNameChars: number;
}

export interface KbRevisionDto {
  revision: number;
  atUtc: string;
  byName: string;
  title: string;
  body: string;
  visibility: KbVisibility;
  status: KbArticleStatus;
}

export interface KbSearchRequest {
  query: string | null;
  categoryId: number | null;
  customerId: number | null;
  visibility: KbVisibility | null;
  status: KbArticleStatus | null;
  tag: string | null;
  skip: number;
  take: number;
}

export interface KbSearchResultDto {
  articles: KbArticleSummaryDto[];
  totalCount: number;
  hasMore: boolean;
}

export interface LeadActivityDto {
  id: number;
  leadId: number;
  kind: LeadActivityKind;
  kindLabel: string;
  body: string;
  actorName: string;
  whenUtc: string;
}

export interface LeadDetailDto {
  lead: LeadDto;
  activities: LeadActivityDto[];
}

export interface LeadDto {
  id: number;
  company: string;
  contactName: string;
  email: string;
  phone: string;
  website: string;
  address: string;
  source: LeadSource;
  sourceLabel: string;
  sourceDetail: string;
  status: LeadStatus;
  statusLabel: string;
  estimatedMonthlyValue: number;
  ownerUserId: number | null;
  ownerName: string;
  tags: string[];
  nextFollowUpUtc: string | null;
  notes: string;
  lostReason: string;
  customerId: number | null;
  customerName: string;
  campaignId: number | null;
  unsubscribed: boolean;
  createdUtc: string;
  updatedUtc: string;
  lastActivityUtc: string;
  isFollowUpDue: boolean;
}

export interface LeadListDto {
  leads: LeadDto[];
  pipeline: LeadPipelineDto;
}

export interface LeadPipelineDto {
  stages: LeadStageDto[];
  openCount: number;
  openMonthlyValue: number;
  wonCount: number;
  lostCount: number;
  winRatePercent: number;
  followUpsDue: number;
  newThisMonth: number;
  bySource: LeadSourceCountDto[];
}

export interface LeadSourceCountDto {
  source: LeadSource;
  label: string;
  count: number;
  won: number;
}

export interface LeadStageDto {
  status: LeadStatus;
  label: string;
  count: number;
  monthlyValue: number;
}

export interface LiveDiskMetric {
  name: string;
  totalBytes: number;
  freeBytes: number;
}

export interface LiveGpuMetric {
  name: string;
  utilizationPercent: number;
  memoryUsedBytes: number;
  memoryTotalBytes: number;
}

export interface LiveMetrics {
  deviceId: number;
  cpuPercent: number;
  memoryUsedBytes: number;
  memoryTotalBytes: number;
  disks: LiveDiskMetric[];
  gpus: LiveGpuMetric[];
  temperatures: LiveTemperature[];
  networkRxBytesPerSec: number;
  networkTxBytesPerSec: number;
  uptimeSeconds: number;
  processCount: number;
  capturedUtc: string;
}

export interface LiveMetricsHistory {
  deviceId: number;
  samples: LiveMetrics[];
}

export interface LiveMetricsSettings {
  historyWindowMinutes: number;
  idleSampleSeconds: number;
  watchedSampleSeconds: number;
  maintenanceSampleSeconds: number;
  maintenanceWindowHours: number;
  monitorWatchedPollSeconds: number;
}

export interface LiveTemperature {
  name: string;
  celsius: number;
}

export interface LocalUserDto {
  name: string;
  fullName: string | null;
  description: string | null;
  enabled: boolean;
  isAdministrator: boolean;
  isBuiltIn: boolean;
  passwordNeverExpires: boolean;
  lastLogonUtc: string | null;
  groups: string[];
  isLockedOut: boolean;
  isRemoteDesktopUser: boolean;
}

export interface LocalUserListResult {
  success: boolean;
  error: string | null;
  machineName: string;
  users: LocalUserDto[];
}

export interface LockDeviceRequest {
  message: string | null;
}

export interface LockSessionsRequest {
  message: string | null;
}

export interface LockSessionsResult {
  success: boolean;
  error: string | null;
  sessionsLocked: number;
}

export interface LockedAccountDto {
  email: string;
  portal: boolean;
  displayName: string;
  failedAttempts: number;
  lastFailureUtc: string;
  lockedUntilUtc: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LogoutRequest {
  refreshToken: string;
}

export interface MailAccountDto {
  sendingEnabled: boolean;
  smtpHost: string;
  smtpPort: number;
  smtpSecurity: MailSecurity;
  smtpUsername: string;
  hasSmtpPassword: boolean;
  fromAddress: string;
  fromName: string;
  replyToAddress: string;
  receivingEnabled: boolean;
  pop3Host: string;
  pop3Port: number;
  pop3Security: MailSecurity;
  pop3Username: string;
  hasPop3Password: boolean;
  deleteAfterFetch: boolean;
  createTicketsFromMail: boolean;
  allowInvalidCertificate: boolean;
  invoiceSubjectTemplate: string;
  invoiceBodyTemplate: string;
  updatedUtc: string | null;
  updatedBy: string | null;
  lastPollUtc: string | null;
  lastPollError: string | null;
  lastPollMessages: number;
  canSend: boolean;
  canReceive: boolean;
}

export interface MailChannelResult {
  checked: boolean;
  ok: boolean;
  detail: string;
}

export interface MailSettings {
  maxRecipients: number;
  maxSubjectChars: number;
  maxBodyChars: number;
  sendTimeoutSeconds: number;
  pollSeconds: number;
  maxMessagesPerPoll: number;
  maxInboundBodyChars: number;
  inboundRetentionDays: number;
}

export interface MailTestRequest {
  settings: UpdateMailAccountRequest | null;
  testSmtp: boolean;
  testPop3: boolean;
  sendTestTo: string | null;
}

export interface MailTestResult {
  success: boolean;
  smtp: MailChannelResult;
  pop3: MailChannelResult;
  summary: string;
}

export interface MarkPaidRequest {
  paidUtc: string | null;
}

export interface MarketingSettingsDto {
  postalAddress: string;
  senderName: string;
  formEnabled: boolean;
  formUrl: string;
  formHeading: string;
  formThankYou: string;
  formNotifyEmail: string;
  formDefaultOwnerUserId: number | null;
  formUrlWarning: string | null;
}

export interface MemoryModuleDto {
  slot: string;
  bank: string;
  capacityBytes: number;
  speedMhz: number;
  configuredSpeedMhz: number;
  memoryType: string;
  formFactor: string;
  manufacturer: string;
  partNumber: string;
  serialNumber: string;
}

export interface MetricsReport {
  monitorId: number;
  reachable: boolean;
  metrics: SnmpMetric[];
  polledUtc: string;
}

export interface MobileCommandRequest {
  kind: MobileCommandKind;
  newPasscode: string | null;
  lostMessage: string | null;
  lostPhoneNumber: string | null;
  lostEmailAddress: string | null;
  lostStreetAddress: string | null;
  lostOrganization: string | null;
}

export interface MobileCommandResult {
  success: boolean;
  message: string;
}

export interface MobileEmailConfigDto {
  client: MobileMailClient;
  emailAddressTemplate: string;
  userNameTemplate: string;
  serverHost: string;
  domain: string;
  modernAuth: boolean;
  useSsl: boolean;
  signature: string;
}

export interface MobileEnrollmentDto {
  token: string;
  enrollmentUrl: string;
  qrPngBase64: string;
  expiresUtc: string;
  ownership: MobileOwnership;
  policyName: string;
  singleUse: boolean;
}

export interface MobileEnrollmentRequest {
  ownership: MobileOwnership;
  policyId: number | null;
  validDays: number;
  singleUse: boolean;
}

export interface MobileInfoDto {
  androidDeviceName: string;
  ownership: MobileOwnership;
  managementMode: string;
  appliedState: string;
  policyCompliant: boolean;
  nonCompliance: string[];
  apiLevel: number;
  securityPatchLevel: string;
  encrypted: boolean | null;
  imei: string;
  phoneNumbers: string[];
  carrier: string;
  batteryPercent: number | null;
  lastStatusReportUtc: string | null;
  lastPolicySyncUtc: string | null;
  policyId: number | null;
  policyName: string | null;
  appliedPolicyVersion: number;
  lostModeSinceUtc: string | null;
  lastPublishError: string | null;
}

export interface MobileLocationDto {
  id: number;
  deviceId: number;
  whenUtc: string;
  latitude: number;
  longitude: number;
  accuracyMeters: number | null;
  batteryPercent: number | null;
}

export interface MobilePolicyDto {
  id: number;
  customerId: number;
  name: string;
  isDefault: boolean;
  passcode: MobilePasscodeRequirement;
  screenLockTimeoutSeconds: number;
  maxFailedUnlocksBeforeWipe: number;
  cameraDisabled: boolean;
  screenCaptureDisabled: boolean;
  allowUnknownSources: boolean;
  allowDeveloperSettings: boolean;
  usbFileTransferDisabled: boolean;
  systemUpdate: MobileSystemUpdate;
  updateWindowStartMinutes: number;
  updateWindowEndMinutes: number;
  wifi: MobileWifiDto[];
  email: MobileEmailConfigDto | null;
  updatedUtc: string;
  updatedBy: string | null;
  deviceCount: number;
  lastPublishError: string | null;
}

export interface MobilePolicySaveResult {
  policy: MobilePolicyDto;
  published: number;
  failures: string[];
}

export interface MobileWifiDto {
  ssid: string;
  security: MobileWifiSecurity;
  hasPassphrase: boolean;
  autoConnect: boolean;
  hidden: boolean;
}

export interface MobileWifiInput {
  ssid: string;
  security: MobileWifiSecurity;
  passphrase: string | null;
  autoConnect: boolean;
  hidden: boolean;
}

export interface MonitorDto {
  manufacturer: string;
  model: string;
  serialNumber: string;
  productCode: string;
  yearOfManufacture: number;
  diagonalInches: number;
  connection: string;
}

export interface MonitorMetricsHistory {
  monitorId: number;
  samples: MetricsReport[];
}

export interface MonitorTestResult {
  snmpOk: boolean;
  snmpMessage: string;
  apiChecked: boolean;
  apiOk: boolean;
  apiMessage: string;
  detail: string;
  anyOk: boolean;
}

export interface MotherboardDto {
  manufacturer: string;
  model: string;
  version: string;
  serialNumber: string;
}

export interface NicDto {
  description: string;
  macAddress: string;
  ipAddresses: string[];
}

export interface OsBreakdownRow {
  os: string;
  count: number;
}

export interface OsInfoDto {
  caption: string;
  version: string;
  build: string;
  architecture: string;
  machineName: string;
  domain: string;
  installedUtc: string | null;
  lastBootUtc: string | null;
}

export interface PayPalAccountDto {
  enabled: boolean;
  environment: PayPalEnvironment;
  clientId: string;
  hasClientSecret: boolean;
  currency: string;
  brandName: string;
  ready: boolean;
  updatedUtc: string | null;
  updatedBy: string | null;
}

export interface PayPalTestRequest {
  settings: UpdatePayPalAccountRequest | null;
}

export interface PayPalTestResult {
  success: boolean;
  message: string;
}

export interface PendingUpdateDto {
  updateId: string;
  title: string;
  kbIds: string;
  sizeBytes: number | null;
  downloaded: boolean;
}

export interface PlCustomerRow {
  customerId: number;
  customerName: string;
  revenue: number;
  partsCost: number;
  attributedExpenses: number;
  grossProfit: number;
  marginPercent: number;
}

export interface PlExpenseCategoryRow {
  category: ExpenseCategory;
  categoryName: string;
  accrual: number;
  cash: number;
  directPortion: number;
  count: number;
  sharePercent: number;
}

export interface PlRevenueTypeRow {
  type: string;
  revenue: number;
  cost: number;
  grossProfit: number;
  marginPercent: number;
  sharePercent: number;
}

export interface PlTechnicianRow {
  userId: number;
  userName: string;
  billedHours: number;
  billedValue: number;
  unbilledHours: number;
  unbilledValue: number;
  effectiveHourlyRate: number;
}

export interface PollingAgentDto {
  deviceId: number;
  name: string;
  isOnline: boolean;
  label: string;
}

export interface PortalAccountDto {
  id: number;
  customerId: number;
  customerName: string;
  email: string;
  displayName: string;
  phone: string;
  title: string;
  role: PortalRole;
  status: ApprovalStatus;
  kbAccess: KbAccessLevel;
  effectiveKbAccess: KbAccessLevel;
  disabled: boolean;
  createdUtc: string;
  approvedUtc: string | null;
  approvedBy: string | null;
  lastLoginUtc: string | null;
  employeeId: number | null;
}

export interface PortalAuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresInSeconds: number;
  account: PortalAccountDto;
}

export interface PortalInviteDto {
  id: number;
  customerId: number;
  customerName: string;
  kind: PortalInviteKind;
  email: string;
  grantsRole: PortalRole;
  preApproved: boolean;
  createdUtc: string;
  expiresUtc: string;
  usedUtc: string | null;
  revoked: boolean;
  createdBy: string;
  inviteUrl: string;
}

export interface PortalInvitePreviewDto {
  valid: boolean;
  customerName: string;
  kind: PortalInviteKind;
  email: string;
  grantsRole: PortalRole;
  preApproved: boolean;
  expiresUtc: string | null;
  error: string | null;
}

export interface PortalLoginRequest {
  email: string;
  password: string;
}

export interface PortalRegisterRequest {
  inviteToken: string;
  email: string;
  password: string;
  displayName: string;
  phone: string;
  title: string;
}

export interface PortalRegisterResponse {
  signedIn: boolean;
  status: ApprovalStatus;
  message: string;
  auth: PortalAuthResponse | null;
}

export interface ProfitLossFiguresDto {
  revenue: number;
  laborRevenue: number;
  partsRevenue: number;
  otherRevenue: number;
  costOfSales: number;
  partsCost: number;
  absorbedCost: number;
  directExpenses: number;
  grossProfit: number;
  grossMarginPercent: number;
  operatingExpenses: number;
  netProfit: number;
  netMarginPercent: number;
  taxCollected: number;
  outstanding: number;
  deferredPartsCost: number;
  invoiceCount: number;
  expenseCount: number;
  isLoss: boolean;
}

export interface ProfitLossPeriodDto {
  label: string;
  startUtc: string;
  endUtc: string;
  accrual: ProfitLossFiguresDto;
  cash: ProfitLossFiguresDto;
  byCustomer: PlCustomerRow[];
  byRevenueType: PlRevenueTypeRow[];
  byTechnician: PlTechnicianRow[];
  byExpenseCategory: PlExpenseCategoryRow[];
}

export interface ProfitLossReportDto {
  generatedUtc: string;
  grouping: ProfitLossGrouping;
  fromUtc: string;
  toUtc: string;
  periods: ProfitLossPeriodDto[];
  total: ProfitLossPeriodDto;
}

export interface PurchaseDto {
  id: number;
  ticketId: number;
  ticketTitle: string;
  ticketStatus: TicketStatus;
  customerId: number;
  description: string;
  quantity: number;
  unitCost: number;
  billable: boolean;
  invoiceId: number | null;
  purchaseDateUtc: string;
  createdUtc: string;
  catalogItemId: number | null;
  catalogSku: string;
  unitPrice: number | null;
  priceLabel: string;
  holdLabel: string;
}

export interface PurgeCustomerRequest {
  confirmName: string;
}

export interface PurgeCustomerResult {
  customerName: string;
  retainedInvoiceCount: number;
  deletedInvoiceCount: number;
  deletedTimeEntryCount: number;
  deletedPurchaseCount: number;
  deletedDeviceCount: number;
}

export interface RecurringExpenseDto {
  id: number;
  category: ExpenseCategory;
  categoryName: string;
  description: string;
  vendor: string;
  amount: number;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  directCost: boolean;
  customerId: number | null;
  customerName: string;
  autoMarkPaid: boolean;
  notes: string;
  lastGeneratedUtc: string | null;
  generatedCount: number;
}

export interface RecurringInvoiceDto {
  id: number;
  customerId: number;
  customerName: string;
  name: string;
  interval: RecurrenceInterval;
  intervalLabel: string;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  lines: RecurringInvoiceLineDto[];
  subtotal: number;
  dueDays: number;
  autoIssue: boolean;
  autoEmail: boolean;
  notes: string;
  lastGeneratedUtc: string | null;
  nextDueUtc: string | null;
  generatedCount: number;
  createdUtc: string;
}

export interface RecurringInvoiceLineDto {
  description: string;
  notes: string;
  quantity: number;
  unitPrice: number;
  catalogItemId: number | null;
  amount: number;
}

export interface RecurringInvoiceRequest {
  customerId: number;
  name: string | null;
  interval: RecurrenceInterval;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  lines: RecurringInvoiceLineDto[] | null;
  dueDays: number;
  autoIssue: boolean;
  autoEmail: boolean;
  notes: string | null;
}

export interface RecurringInvoiceRunResult {
  created: number;
  templatesConsidered: number;
  throughUtc: string;
  emailed: number;
  emailFailed: number;
}

export interface RecurringRunResult {
  created: number;
  templatesConsidered: number;
  throughUtc: string;
}

export interface RecurringTicketDto {
  id: number;
  customerId: number;
  customerName: string;
  title: string;
  description: string;
  priority: TicketPriority;
  interval: RecurrenceInterval;
  intervalLabel: string;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  appendPeriodToTitle: boolean;
  notes: string;
  lastGeneratedUtc: string | null;
  nextDueUtc: string | null;
  generatedCount: number;
  createdUtc: string;
}

export interface RecurringTicketRequest {
  customerId: number;
  title: string | null;
  description: string | null;
  priority: TicketPriority;
  interval: RecurrenceInterval;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  appendPeriodToTitle: boolean;
  notes: string | null;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  displayName: string;
}

export interface RemoteFileSettings {
  maxTotalBytes: number;
  maxFiles: number;
  stagingTtlMinutes: number;
}

export interface RemoteFocusState {
  deviceId: number;
  textField: boolean;
  source: RemoteFocusSource;
  observedUtc: string;
}

export interface RemoteInput {
  kind: RemoteInputKind;
  x: number;
  y: number;
  button: RemoteMouseButton;
  wheelDelta: number;
  virtualKey: number;
  text: string | null;
}

export interface RemoteSessionOptions {
  maxWidth: number;
  jpegQuality: number;
  targetFps: number;
  viewOnly: boolean;
  shareClipboard: boolean;
  enableAudio: boolean;
  monitorId: string | null;
}

export interface RemoteSessionState {
  deviceId: number;
  active: boolean;
  message: string | null;
}

export interface RemoteTicketRedeemRequest {
  ticket: string;
}

export interface RemoteTicketRedeemResponse {
  accessToken: string;
  deviceId: number;
  deviceName: string;
}

export interface RemoteTicketRequest {
  deviceId: number;
}

export interface RemoteTicketResponse {
  ticket: string;
  deviceId: number;
}

export interface RemoveMobileManagementRequest {
  confirmName: string | null;
  wipeExternalStorage: boolean;
  preserveResetProtection: boolean;
  reason: string | null;
}

export interface ReportSummaryDto {
  generatedUtc: string;
  fromUtc: string | null;
  toUtc: string | null;
  billing: BillingReportDto;
  tickets: TicketReportDto;
  devices: DeviceReportDto;
  time: TimeReportDto;
  catalog: CatalogReportDto;
}

export interface ResetHostPasswordRequest {
  password: string | null;
}

export interface ResetLocalUserPasswordRequest {
  userName: string;
  newPassword: string;
  mustChangePassword: boolean;
  unlock: boolean;
}

export interface ResetLocalUserPasswordResult {
  success: boolean;
  error: string | null;
  wasUnlocked: boolean;
  user: LocalUserDto | null;
}

export interface ResetStaffPasswordRequest {
  password: string | null;
  mustChangePassword: boolean;
}

export interface ResolvedRate {
  rate: number;
  kind: RateKind;
  explanation: string;
}

export interface RestoreBackupRequest {
  fileName: string | null;
  confirmPhrase: string | null;
  restartNow: boolean;
}

export interface RestoreBackupResult {
  success: boolean;
  summary: string;
  error: string | null;
  restartRequired: boolean;
}

export interface RevealRecoveryKeyRequest {
  protectorId: string | null;
}

export interface RunBackupResult {
  success: boolean;
  summary: string;
  backup: BackupDto | null;
  error: string | null;
}

export interface SaveCampaignRequest {
  name: string;
  subject: string;
  body: string;
  audience: CampaignAudienceDto;
}

export interface SaveFilesCommand {
  transferId: string;
  targetDirectory: string;
  files: ClipboardFileInfo[];
}

export interface SaveForumCategoryRequest {
  name: string;
  description: string;
  sortOrder: number;
  staffOnly: boolean;
}

export interface SaveKbArticleRequest {
  title: string;
  body: string;
  excerpt: string;
  categoryId: number | null;
  tags: string[];
  visibility: KbVisibility;
  status: KbArticleStatus;
  customerId: number | null;
}

export interface SaveKbCategoryRequest {
  name: string;
  description: string;
  sortOrder: number;
  customerId: number | null;
}

export interface SaveMobilePolicyRequest {
  name: string;
  isDefault: boolean;
  passcode: MobilePasscodeRequirement;
  screenLockTimeoutSeconds: number;
  maxFailedUnlocksBeforeWipe: number;
  cameraDisabled: boolean;
  screenCaptureDisabled: boolean;
  allowUnknownSources: boolean;
  allowDeveloperSettings: boolean;
  usbFileTransferDisabled: boolean;
  systemUpdate: MobileSystemUpdate;
  updateWindowStartMinutes: number;
  updateWindowEndMinutes: number;
  wifi: MobileWifiInput[] | null;
  email: MobileEmailConfigDto | null;
}

export interface SaveWindowsPolicyRequest {
  name: string;
  isDefault: boolean;
  settings: WindowsPolicySettings | null;
}

export interface ScreenFrame {
  deviceId: number;
  width: number;
  height: number;
  jpeg: string;
  desktop: RemoteDesktopKind;
  capturedUtc: string;
}

export interface SecurityAlertDto {
  notifyEmail: string;
  deliverable: boolean;
  lastAlertUtc: string | null;
  pendingLockouts: number;
}

export interface ServerBuildManifest {
  product: string;
  version: string;
  rid: string;
}

export interface ServerReleaseDto {
  version: string;
  notes: string | null;
  publishedUtc: string | null;
  sizeBytes: number;
  installed: boolean;
}

export interface ServerSnapshotDto {
  name: string;
  fromVersion: string;
  toVersion: string;
  takenUtc: string;
  sizeBytes: number;
}

export interface ServerUpdateActionResult {
  success: boolean;
  summary: string;
  error: string | null;
  restarting: boolean;
}

export interface ServerUpdateConfigDto {
  autoUpdate: boolean;
  feedUrl: string;
  checkHours: number;
  keepVersions: number;
  skippedVersions: string[];
}

export interface ServerUpdateFeed {
  releases: ServerUpdateFeedEntry[] | null;
}

export interface ServerUpdateFeedEntry {
  version: string;
  rid: string;
  url: string;
  sha256: string;
  size: number;
  publishedUtc: string | null;
  notes: string | null;
}

export interface ServerUpdateStatusDto {
  managed: boolean;
  unmanagedReason: string | null;
  runningVersion: string;
  packagedVersion: string | null;
  activeVersion: string | null;
  config: ServerUpdateConfigDto;
  versions: ServerVersionDto[];
  available: ServerReleaseDto[];
  latestVersion: string | null;
  updateAvailable: boolean;
  lastCheckUtc: string | null;
  lastCheckError: string | null;
  lastFailure: string | null;
  snapshots: ServerSnapshotDto[];
  busy: string | null;
}

export interface ServerVersionDto {
  version: string;
  packaged: boolean;
  active: boolean;
  running: boolean;
  bad: boolean;
  skipped: boolean;
  installedUtc: string | null;
  sizeBytes: number;
  hasSnapshot: boolean;
}

export interface ServiceControlRequest {
  name: string;
  action: ServiceAction;
  stopDependents: boolean;
}

export interface ServiceControlResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  service: DeviceServiceDto | null;
  affectedDependents: string[];
  warning: string | null;
}

export interface ServiceRecoveryDto {
  firstFailure: ServiceFailureAction;
  secondFailure: ServiceFailureAction;
  subsequentFailures: ServiceFailureAction;
  resetAfterSeconds: number;
  restartDelaySeconds: number;
  command: string | null;
}

export interface SetAcceptedAnswerRequest {
  postId: number | null;
}

export interface SetCustomerCatalogPriceRequest {
  unitPrice: number;
}

export interface SetForumLockedRequest {
  locked: boolean;
}

export interface SetForumPinnedRequest {
  pinned: boolean;
}

export interface SetKbCustomerAccessRequest {
  access: KbAccessLevel;
}

export interface SetLeadStatusRequest {
  status: LeadStatus;
  lostReason: string | null;
}

export interface SetLocalUserEnabledRequest {
  userName: string;
  enabled: boolean;
}

export interface SetLocalUserEnabledResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  user: LocalUserDto | null;
}

export interface SetLocalUserGroupsRequest {
  userName: string;
  administrator: boolean;
  remoteDesktop: boolean;
}

export interface SetLocalUserGroupsResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  user: LocalUserDto | null;
}

export interface SetMaintenanceModeRequest {
  enabled: boolean;
}

export interface SetPortalAccountAccessRequest {
  kbAccess: KbAccessLevel;
}

export interface SetPortalAccountDisabledRequest {
  disabled: boolean;
}

export interface SetPrimaryContactRequest {
  accountId: number;
}

export interface SetServiceAccountRequest {
  name: string;
  account: string;
  password: string | null;
}

export interface SetServiceAccountResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  service: DeviceServiceDto | null;
  grantedLogonRight: boolean;
  restartRequired: boolean;
}

export interface SetServiceRecoveryRequest {
  name: string;
  firstFailure: ServiceFailureAction;
  secondFailure: ServiceFailureAction;
  subsequentFailures: ServiceFailureAction;
  resetAfterSeconds: number;
  restartDelaySeconds: number;
}

export interface SetServiceRecoveryResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  service: DeviceServiceDto | null;
}

export interface SetServiceStartupTypeRequest {
  name: string;
  startupType: ServiceStartupType;
}

export interface SetServiceStartupTypeResult {
  success: boolean;
  error: string | null;
  changed: boolean;
  service: DeviceServiceDto | null;
}

export interface SetTenantStatusRequest {
  suspended: boolean;
  reason: string | null;
}

export interface ShellCommandRequest {
  shell: ShellKind;
  command: string;
  workingDirectory: string | null;
  timeoutSeconds: number;
}

export interface ShellCommandResult {
  success: boolean;
  error: string | null;
  exitCode: number;
  output: string;
  errorOutput: string;
  timedOut: boolean;
  outputTruncated: boolean;
  workingDirectory: string;
  durationMs: number;
  shell: ShellKind;
}

export interface SignInFailureDto {
  id: number;
  whenUtc: string;
  email: string;
  portal: boolean;
  reason: SignInFailureReason;
  reasonText: string;
  ipAddress: string;
  userAgent: string;
  causedLockout: boolean;
}

export interface SignInFailureListDto {
  failures: SignInFailureDto[];
  totalStored: number;
  sinceHours: number;
  inWindow: number;
}

export interface SignInSettings {
  maxFailedAttempts: number;
  windowMinutes: number;
  lockoutMinutes: number;
  logRetentionDays: number;
  maxStoredFailures: number;
  alertCooldownMinutes: number;
}

export interface SiteDto {
  id: number;
  customerId: number;
  name: string;
  address: string;
  subnet: string;
}

export interface SnmpCredentialShape {
  version: SnmpVersion;
  securityLevel: SnmpSecurityLevel;
  authProtocol: SnmpAuthProtocol;
  privProtocol: SnmpPrivProtocol;
  securityName: string;
  port: number;
}

export interface SnmpCredentials {
  version: SnmpVersion;
  community: string;
  securityLevel: SnmpSecurityLevel;
  securityName: string;
  authProtocol: SnmpAuthProtocol;
  authPassword: string;
  privProtocol: SnmpPrivProtocol;
  privPassword: string;
  port: number;
}

export interface SnmpInfo {
  community: string;
  sysName: string;
  sysDescr: string;
  sysObjectId: string;
  sysContact: string;
  sysLocation: string;
  sysUpTimeTicks: number;
  sysServices: number;
}

export interface SnmpMetric {
  name: string;
  value: string;
  unit: string;
  group: string;
  numeric: number | null;
  max: number | null;
  isChartable: boolean;
  seriesKey: string;
}

export interface SnmpMonitorDto {
  id: number;
  customerId: number;
  siteId: number | null;
  displayName: string;
  ipAddress: string;
  macAddress: string;
  hostname: string;
  kind: DiscoveredDeviceKind;
  snmpVersionLabel: string;
  pollSeconds: number;
  online: boolean;
  lastPolledUtc: string | null;
  discoveredByDeviceId: number;
  latestMetrics: SnmpMetric[];
  synologyPlatform: SynologyPlatform;
  synology: SynologyInventory | null;
  lastInventoryUtc: string | null;
  hasApiCredentials: boolean;
  inventoryError: string;
  credentials: SnmpCredentialShape | null;
  inventorySeconds: number;
  synologyApi: SynologyApiShape | null;
  agentDeviceId: number | null;
  agentDeviceName: string;
  maintenanceUntilUtc: string | null;
  maintenanceActive: boolean;
  isSynology: boolean;
  hasAgent: boolean;
  statusLabel: string;
  isHealthy: boolean;
  isUnhealthy: boolean;
  lastPolledLabel: string;
  kindLabel: string;
}

export interface SnmpMonitorSpec {
  monitorId: number;
  ipAddress: string;
  kind: DiscoveredDeviceKind;
  pollSeconds: number;
  credentials: SnmpCredentials;
  synology: SynologyMonitorSpec | null;
  watched: boolean;
  maintenanceUntilUtc: string | null;
  resolvedSynologyPlatform: SynologyPlatform;
}

export interface SnmpTestRequest {
  ipAddress: string;
  credentials: SnmpCredentials;
  pollingDeviceId: number;
}

export interface SnmpTestResult {
  ok: boolean;
  message: string;
  sysName: string;
  sysDescr: string;
  uptimeLabel: string;
}

export interface SoftwareInstallJobDto {
  id: number;
  deviceId: number;
  deviceName: string;
  packageId: number;
  packageName: string;
  packageVersion: string;
  state: SoftwareInstallState;
  percent: number;
  message: string;
  exitCode: number | null;
  requestedUtc: string;
  requestedBy: string;
  startedUtc: string | null;
  finishedUtc: string | null;
  isFinished: boolean;
  stateLabel: string;
  packageDisplayName: string;
  hasPercent: boolean;
}

export interface SoftwareInstallProgress {
  jobId: number;
  deviceId: number;
  state: SoftwareInstallState;
  percent: number;
  message: string;
  exitCode: number | null;
}

export interface SoftwareInventoryDto {
  antivirus: AntivirusProductDto[];
  software: InstalledSoftwareDto[];
  patches: InstalledPatchDto[];
  collectedUtc: string;
  pendingReboot: boolean;
  pendingUpdates: PendingUpdateDto[] | null;
  stoppedServices: StoppedServiceDto[] | null;
}

export interface SoftwarePackageDto {
  id: number;
  name: string;
  version: string;
  publisher: string;
  notes: string;
  source: SoftwarePackageSource;
  downloadUrl: string;
  fileName: string;
  sha256: string;
  sizeBytes: number;
  arguments: string;
  successExitCodes: number[];
  timeoutMinutes: number;
  active: boolean;
  createdUtc: string;
  createdBy: string;
  updatedUtc: string;
  fileMissing: boolean;
  installCount: number;
  displayName: string;
  sourceText: string;
  detailText: string;
  warningText: string;
  hasWarning: boolean;
  canInstall: boolean;
  isUploadPackage: boolean;
}

export interface SoftwareUninstallResult {
  deviceId: number;
  kind: string;
  target: string;
  success: boolean;
  message: string;
}

export interface StartHostTrialRequest {
  days: number | null;
  notify: boolean;
}

export interface StartTimerRequest {
  customerId: number;
  ticketId: number;
  notes: string;
}

export interface StopTimerRequest {
  notes: string;
  billable: boolean;
}

export interface StoppedServiceDto {
  name: string;
  displayName: string;
  exitCode: number;
  reason: string;
}

export interface SuppressionDto {
  id: number;
  email: string;
  reason: string;
  whenUtc: string;
  campaignId: number | null;
  addedBy: string;
}

export interface SynologyApiShape {
  username: string;
  port: number;
  useHttps: boolean;
  allowUntrustedCertificate: boolean;
}

export interface SynologyCredentials {
  username: string;
  password: string;
  port: number;
  useHttps: boolean;
  allowUntrustedCertificate: boolean;
  hasLogin: boolean;
}

export interface SynologyDisk {
  name: string;
  model: string;
  type: string;
  status: string;
  temperatureC: number;
  sizeBytes: number;
  unhealthy: boolean;
}

export interface SynologyInventory {
  platform: SynologyPlatform;
  model: string;
  serialNumber: string;
  firmwareVersion: string;
  hostname: string;
  uptimeSeconds: number;
  systemStatus: string;
  temperatureC: number;
  updateAvailable: boolean;
  availableVersion: string;
  volumes: SynologyVolume[];
  disks: SynologyDisk[];
  sources: string;
}

export interface SynologyInventoryReport {
  monitorId: number;
  reachable: boolean;
  error: string;
  inventory: SynologyInventory | null;
  collectedUtc: string;
}

export interface SynologyMonitorSpec {
  platform: SynologyPlatform;
  api: SynologyCredentials;
  inventorySeconds: number;
}

export interface SynologySettings {
  minInventorySeconds: number;
  defaultInventorySeconds: number;
  maxVolumes: number;
  maxDisks: number;
  maxTextLength: number;
  apiTimeoutSeconds: number;
  testTimeoutSeconds: number;
}

export interface SynologyTestRequest {
  ipAddress: string;
  platform: SynologyPlatform;
  snmp: SnmpCredentials;
  api: SynologyCredentials;
  pollingDeviceId: number;
}

export interface SynologyTestResult {
  snmpOk: boolean;
  snmpMessage: string;
  apiOk: boolean;
  apiMessage: string;
  detectedPlatform: SynologyPlatform;
  model: string;
  firmwareVersion: string;
  serialNumber: string;
  anyOk: boolean;
}

export interface SynologyVolume {
  name: string;
  status: string;
  raidType: string;
  totalBytes: number;
  usedBytes: number;
  unhealthy: boolean;
  usedPercent: number;
}

export interface TenantDto {
  id: number;
  name: string;
  slug: string;
  status: TenantStatus;
  suspendedReason: string | null;
  notes: string | null;
  createdUtc: string;
  isDefault: boolean;
  customers: number | null;
  devices: number | null;
  staffUsers: number | null;
  startError: string | null;
}

export interface TerminateHostPlanRequest {
  reason: string | null;
  notify: boolean;
}

export interface TestMonitorRequest {
  credentials: SnmpCredentials | null;
  credentialShape: SnmpCredentialShape | null;
  ipAddress: string | null;
  kind: DiscoveredDeviceKind | null;
  pollingDeviceId: number | null;
  synologyPlatform: SynologyPlatform | null;
  synologyApi: SynologyCredentials | null;
}

export interface TicketAlertDto {
  notifyEmail: string;
  deliverable: boolean;
  lastAlertUtc: string | null;
}

export interface TicketDto {
  id: number;
  customerId: number;
  deviceId: number | null;
  title: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  source: TicketSource;
  reporterEmployeeId: number | null;
  assigneeUserId: number | null;
  createdUtc: string;
  updatedUtc: string;
  notes: TicketNoteDto[];
  recurringId: number | null;
  sourceEmail: string | null;
  sourceName: string | null;
  contactEmail: string | null;
  contactName: string | null;
  statusLabel: string;
  isBillable: boolean;
  isRecurring: boolean;
}

export interface TicketNoteDto {
  id: number;
  authorName: string;
  body: string;
  createdUtc: string;
  isInternal: boolean;
  emailedTo: string | null;
  emailedUtc: string | null;
  emailError: string | null;
}

export interface TicketReportDto {
  total: number;
  open: number;
  inProgress: number;
  waiting: number;
  resolved: number;
  closed: number;
  low: number;
  normal: number;
  high: number;
  urgent: number;
  fromAgent: number;
  fromManual: number;
  avgResolutionHours: number;
  byCustomer: CustomerTicketRow[];
}

export interface TimeEntryDto {
  id: number;
  ticketId: number;
  ticketTitle: string;
  ticketStatus: TicketStatus;
  customerId: number;
  userId: number;
  userName: string;
  startUtc: string;
  endUtc: string | null;
  minutes: number;
  rawMinutes: number;
  rate: number;
  rateKind: RateKind;
  billable: boolean;
  notes: string;
  invoiceId: number | null;
  amount: number;
  holdLabel: string;
}

export interface TimeReportDto {
  billableMinutes: number;
  nonBillableMinutes: number;
  rawMinutes: number;
  billableValue: number;
  byUser: UserTimeRow[];
  byCustomer: CustomerTimeRow[];
}

export interface TpmDto {
  present: boolean;
  enabled: boolean;
  activated: boolean;
  owned: boolean;
  specVersion: string;
  manufacturer: string;
  manufacturerVersion: string;
}

export interface UninstallPatchRequest {
  hotFixId: string;
}

export interface UninstallSoftwareCommand {
  key: string;
  expectedName: string;
}

export interface UninstallSoftwareRequest {
  key: string;
}

export interface UnlockAccountRequest {
  email: string | null;
  portal: boolean;
}

export interface UpdateAndroidAccountRequest {
  enabled: boolean | null;
  serviceAccountKeyJson: string | null;
  topicName: string | null;
  subscriptionName: string | null;
}

export interface UpdateAutoBillingRequest {
  enabled: boolean;
  dayOfMonth: number;
}

export interface UpdateBackupConfigRequest {
  enabled: boolean | null;
  frequency: BackupFrequency | null;
  hourLocal: number | null;
  dayOfWeek: DayOfWeek | null;
  destinationPath: string | null;
  username: string | null;
  password: string | null;
  keepCount: number | null;
  keepDays: number | null;
  includeMedia: boolean | null;
  notifyEmail: string | null;
}

export interface UpdateBillingConfigRequest {
  standardRate: number;
  afterHoursMultiplier: number;
  weekendMultiplier: number;
  afterHoursStartHour: number;
  afterHoursEndHour: number;
  billingIncrementMinutes: number;
  minimumMinutes: number;
  taxPercent: number;
  purchaseMarkupPercent: number;
}

export interface UpdateCatalogItemRequest {
  sku: string;
  name: string;
  description: string;
  kind: CatalogItemKind;
  unitCost: number;
  listPrice: number | null;
  vendor: string;
  active: boolean;
}

export interface UpdateCustomerRequest {
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  billingTerms: string;
  defaultRate: number;
}

export interface UpdateEmployeeRequest {
  fullName: string;
  email: string;
  phone: string;
  title: string;
}

export interface UpdateExpenseRequest {
  incurredUtc: string;
  paidUtc: string | null;
  category: ExpenseCategory;
  description: string;
  vendor: string;
  amount: number;
  customerId: number | null;
  directCost: boolean;
  notes: string;
}

export interface UpdateHostBillingSettingsRequest {
  enabled: boolean | null;
  billingDay: number | null;
  dueDays: number | null;
  taxPercent: number | null;
  reminderDays: number | null;
  invoicePrefix: string | null;
  issuerName: string | null;
  issuerAddress: string | null;
  issuerEmail: string | null;
  footerNote: string | null;
  trialDays: number | null;
  trialForNewOrganizations: boolean | null;
}

export interface UpdateHostTenantBillingRequest {
  enabled: boolean | null;
  planName: string | null;
  baseMonthly: number | null;
  perDevice: number | null;
  includedDevices: number | null;
  perStaff: number | null;
  includedStaff: number | null;
  taxPercent: number | null;
  clearTaxPercent: boolean | null;
  billingName: string | null;
  billingEmail: string | null;
  billingAddress: string | null;
  notes: string | null;
  interval: HostBillingInterval | null;
}

export interface UpdateHostUserRequest {
  displayName: string | null;
  disabled: boolean | null;
  permissions: HostPermission | null;
  allOrganizations: boolean | null;
  organizations: HostTenantAssignment[] | null;
}

export interface UpdateInvoiceLineRequest {
  description: string;
  notes: string;
  date: string | null;
  quantity: number;
  unitPrice: number;
}

export interface UpdateInvoiceRequest {
  dueUtc: string | null;
}

export interface UpdateLeadRequest {
  company: string;
  contactName: string;
  email: string;
  phone: string;
  website: string;
  address: string;
  source: LeadSource;
  sourceDetail: string;
  estimatedMonthlyValue: number;
  ownerUserId: number | null;
  tags: string[] | null;
  nextFollowUpUtc: string | null;
  notes: string;
}

export interface UpdateMailAccountRequest {
  sendingEnabled: boolean | null;
  smtpHost: string | null;
  smtpPort: number | null;
  smtpSecurity: MailSecurity | null;
  smtpUsername: string | null;
  smtpPassword: string | null;
  fromAddress: string | null;
  fromName: string | null;
  replyToAddress: string | null;
  receivingEnabled: boolean | null;
  pop3Host: string | null;
  pop3Port: number | null;
  pop3Security: MailSecurity | null;
  pop3Username: string | null;
  pop3Password: string | null;
  deleteAfterFetch: boolean | null;
  createTicketsFromMail: boolean | null;
  allowInvalidCertificate: boolean | null;
  invoiceSubjectTemplate: string | null;
  invoiceBodyTemplate: string | null;
}

export interface UpdateMarketingSettingsRequest {
  postalAddress: string | null;
  senderName: string | null;
  formEnabled: boolean | null;
  formHeading: string | null;
  formThankYou: string | null;
  formNotifyEmail: string | null;
  formDefaultOwnerUserId: number | null;
  clearFormDefaultOwner: boolean | null;
  rotateFormKey: boolean;
}

export interface UpdatePayPalAccountRequest {
  enabled: boolean | null;
  environment: PayPalEnvironment | null;
  clientId: string | null;
  clientSecret: string | null;
  currency: string | null;
  brandName: string | null;
}

export interface UpdatePurchaseRequest {
  ticketId: number;
  description: string;
  quantity: number;
  unitCost: number;
  billable: boolean;
  purchaseDateUtc: string;
  catalogItemId: number | null;
  unitPrice: number | null;
}

export interface UpdateRecurringExpenseRequest {
  category: ExpenseCategory;
  description: string;
  vendor: string;
  amount: number;
  dayOfMonth: number;
  startUtc: string;
  endUtc: string | null;
  active: boolean;
  directCost: boolean;
  customerId: number | null;
  autoMarkPaid: boolean;
  notes: string;
}

export interface UpdateSecurityAlertRequest {
  notifyEmail: string | null;
}

export interface UpdateServerUpdateConfigRequest {
  autoUpdate: boolean | null;
  feedUrl: string | null;
  checkHours: number | null;
  keepVersions: number | null;
  clearSkipped: boolean | null;
}

export interface UpdateSnmpMonitorRequest {
  displayName: string;
  pollSeconds: number;
  credentials: SnmpCredentials | null;
  credentialShape: SnmpCredentialShape | null;
  ipAddress: string | null;
  kind: DiscoveredDeviceKind | null;
  pollingDeviceId: number | null;
  synologyPlatform: SynologyPlatform | null;
  inventorySeconds: number | null;
  synologyApi: SynologyCredentials | null;
}

export interface UpdateSoftwarePackageRequest {
  name: string | null;
  version: string | null;
  publisher: string | null;
  notes: string | null;
  source: SoftwarePackageSource | null;
  downloadUrl: string | null;
  fileName: string | null;
  sha256: string | null;
  arguments: string | null;
  successExitCodes: string | null;
  timeoutMinutes: number | null;
  active: boolean | null;
}

export interface UpdateStaffUserRequest {
  displayName: string | null;
  role: string | null;
  disabled: boolean | null;
}

export interface UpdateTenantRequest {
  name: string | null;
  notes: string | null;
}

export interface UpdateTicketAlertRequest {
  notifyEmail: string | null;
}

export interface UpdateTicketRequest {
  title: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  assigneeUserId: number | null;
}

export interface UpdateTimeEntryRequest {
  ticketId: number;
  startUtc: string;
  endUtc: string | null;
  minutes: number;
  rate: number;
  billable: boolean;
  notes: string;
}

export interface UserDto {
  id: number;
  email: string;
  displayName: string;
  role: string;
  createdUtc: string;
  mustChangePassword: boolean;
  disabled: boolean;
  lastSignInUtc: string | null;
}

export interface UserTimeRow {
  userId: number;
  userName: string;
  billableMinutes: number;
  billableValue: number;
}

export interface WakeDeviceRequest {
  viaDeviceId: number | null;
}

export interface WakeDeviceResponse {
  success: boolean;
  error: string | null;
  detail: string;
  packetsSent: number;
  sentByDeviceId: number;
  sentByDeviceName: string;
  macAddresses: string[];
}

export interface WakeOnLanCommand {
  macAddresses: string[];
  unicastAddress: string | null;
  broadcastAddress: string | null;
  port: number;
}

export interface WakeOnLanResult {
  success: boolean;
  error: string | null;
  detail: string;
  packetsSent: number;
}

export interface WindowsComplianceDto {
  policyId: number;
  policyVersion: string;
  checks: WindowsPolicyCheck[];
  edition: string;
  domainJoined: boolean;
  collectedUtc: string;
  enforced: boolean;
  enforcementNote: string | null;
}

export interface WindowsPolicyCheck {
  setting: string;
  label: string;
  state: PolicyCheckState;
  expected: string;
  actual: string;
  detail: string | null;
  enforcement: PolicyEnforcement;
  enforcementDetail: string | null;
}

export interface WindowsPolicyCheckResult {
  success: boolean;
  error: string | null;
  compliance: WindowsComplianceDto | null;
}

export interface WindowsPolicyDto {
  id: number;
  customerId: number;
  name: string;
  isDefault: boolean;
  settings: WindowsPolicySettings;
  updatedUtc: string;
  updatedBy: string | null;
  deviceCount: number;
  checkedSettings: number;
}

export interface WindowsPolicySaveResult {
  policy: WindowsPolicyDto;
  pushed: number;
}

export interface WindowsPolicySettings {
  requireBitLocker: boolean | null;
  requireDefenderRealtime: boolean | null;
  requireFirewall: boolean | null;
  maxScreenLockMinutes: number | null;
  minPasswordLength: number | null;
  maxPasswordAgeDays: number | null;
  minPasswordHistory: number | null;
  maxLockoutThreshold: number | null;
  minQualityDeferralDays: number | null;
  minFeatureDeferralDays: number | null;
  requireNoAutoRestartWithUsers: boolean | null;
  requireUsbStorageBlocked: boolean | null;
  requireMicrosoftAccountsBlocked: boolean | null;
  requireCameraDisabled: boolean | null;
  requireStoreDisabled: boolean | null;
}

export interface WindowsPolicySpec {
  policyId: number;
  name: string;
  version: string;
  settings: WindowsPolicySettings;
}

export interface WorkTimerDto {
  id: number;
  customerId: number;
  ticketId: number;
  ticketTitle: string;
  userId: number;
  userName: string;
  startedUtc: string;
  notes: string;
  elapsedMinutes: number;
}

// =====================================================================
//  Constant holders. Only `const` fields travel: a static property that reads
//  AppSettings.Current is an instance setting this app fetches from GET /api/settings,
//  and baking a build-time copy of one would leave the UI clamping to the old value.
// =====================================================================

export const AgentDiagnosticLimits = {
  MaxTextLength: 400,
  MaxDetailLength: 2000,
  MaxChecks: 40,
  MaxLogEntries: 40,
  MaxLogMessageLength: 4000,
} as const;

export const AgentHubMethods = {
  ReportInventory: 'ReportInventory',
  Heartbeat: 'Heartbeat',
  ReportUninstalled: 'ReportUninstalled',
  ReportLiveMetrics: 'ReportLiveMetrics',
  ReportLiveMetricsHistory: 'ReportLiveMetricsHistory',
  ReportMaintenanceSample: 'ReportMaintenanceSample',
  ReportSoftwareInventory: 'ReportSoftwareInventory',
  ReportWindowsCompliance: 'ReportWindowsCompliance',
  EscrowBitLockerKey: 'EscrowBitLockerKey',
  ReportDeviceLock: 'ReportDeviceLock',
  ReportSoftwareUninstallResult: 'ReportSoftwareUninstallResult',
  ReportSoftwareInstallProgress: 'ReportSoftwareInstallProgress',
  ReportDeviceEvents: 'ReportDeviceEvents',
  ReportInputFocus: 'ReportInputFocus',
  ReportDisplays: 'ReportDisplays',
} as const;

export const AgentPayloads = {
  Windows: 'windows',
  SynologyLinuxX64: 'synology-linux-x64',
  SynologyLinuxArm64: 'synology-linux-arm64',
  SynologyLinuxArm: 'synology-linux-arm',
} as const;

export const AttachmentLimits = {
  MaxFileNameChars: 160,
} as const;

export const AuditLimits = {
  DefaultPageSize: 100,
  MaxPageSize: 500,
  MaxExportRows: 50000,
  MaxActorChars: 200,
  MaxActionChars: 120,
  MaxSummaryChars: 300,
  MaxDetailChars: 2000,
  MaxTargetChars: 120,
  MaxTargetNameChars: 200,
  MaxPathChars: 400,
  MaxUserAgentChars: 400,
  MaxSearchChars: 200,
} as const;

export const AuditTargets = {
  Device: 'device',
  Customer: 'customer',
  Invoice: 'invoice',
  Ticket: 'ticket',
  Monitor: 'monitor',
  Package: 'package',
  Employee: 'employee',
  Expense: 'expense',
  RecurringExpense: 'recurring-expense',
  CatalogItem: 'catalog-item',
  PortalAccount: 'portal-account',
  PortalInvite: 'portal-invite',
  Discovered: 'discovered',
  StaffUser: 'staff',
  Article: 'article',
  KbCategory: 'kb-category',
  Thread: 'thread',
  Post: 'post',
  ForumCategory: 'forum-category',
  TimeEntry: 'time',
  Purchase: 'purchase',
  Site: 'site',
  Backup: 'backup',
  RecurringInvoice: 'recurring-invoice',
  RecurringTicket: 'recurring-ticket',
  Lead: 'lead',
  Campaign: 'campaign',
} as const;

export const AutoBillingLimits = {
  MinDay: 1,
  MaxDay: 28,
} as const;

export const BackupLimits = {
  RestorePhrase: 'RESTORE',
  FileNamePrefix: 'JetsonCRM-Backup-',
  FileNameExtension: '.zip',
  ManifestEntryName: 'manifest.json',
  DatabaseEntryName: 'jetsoncrm.db',
  MaxStoredRuns: 100,
  FailureReminderHours: 24,
  MaxNotifyRecipients: 10,
  SchemaVersion: 1,
} as const;

export const DeviceLockAgentMethods = {
  LockSessions: 'LockSessions',
} as const;

export const DeviceLockLimits = {
  MaxMessageChars: 200,
  NoticeCaption: 'This PC is locked',
  DefaultNotice: 'This PC has been locked by your IT provider. Contact them to unlock it.',
} as const;

export const DiscoveryAgentMethods = {
  ReportDiscovery: 'ReportDiscovery',
  ReportDeployResult: 'ReportDeployResult',
} as const;

export const DiscoveryUiMethods = {
  ScanNetwork: 'ScanNetwork',
} as const;

export const EventLogAgentMethods = {
  QueryEventLog: 'QueryEventLog',
} as const;

export const FileExplorerAgentMethods = {
  BrowseFiles: 'BrowseFiles',
  PerformFileOperation: 'PerformFileOperation',
  FetchFile: 'FetchFile',
  SaveFiles: 'SaveFiles',
} as const;

export const ForumLimits = {
  MaxTitleChars: 200,
  MaxBodyChars: 65536,
  DefaultPageSize: 25,
  MaxPageSize: 100,
  MaxMediaPerPost: 12,
} as const;

export const HardwareFacts = {
  MaxGpus: 8,
  MaxMemoryModules: 64,
  MaxMonitors: 16,
  MaxBatteries: 8,
  MaxTextLength: 200,
} as const;

export const HostBillingLimits = {
  MaxPrefixLength: 12,
  MaxTextLength: 500,
  MaxDueDays: 120,
  MaxReminderDays: 60,
  MaxReminders: 6,
  DefaultTrialDays: 30,
  MaxTrialDays: 180,
  TrialReminderDays: 7,
} as const;

export const HubRoutes = {
  Agent: '/hubs/agent',
  Ui: '/hubs/ui',
} as const;

export const LeadLimits = {
  MaxTextLength: 200,
  MaxNotesLength: 8000,
  MaxTags: 10,
  MaxTagLength: 40,
  MaxActivityLength: 8000,
  MaxListed: 2000,
} as const;

export const LocalUserAgentMethods = {
  ListLocalUsers: 'ListLocalUsers',
  CreateLocalUser: 'CreateLocalUser',
  ResetLocalUserPassword: 'ResetLocalUserPassword',
  SetLocalUserEnabled: 'SetLocalUserEnabled',
  DeleteLocalUser: 'DeleteLocalUser',
  SetLocalUserGroups: 'SetLocalUserGroups',
} as const;

export const LocalUserLimits = {
  MaxUserNameChars: 20,
  MaxFullNameChars: 256,
  MaxDescriptionChars: 48,
  MaxPasswordChars: 127,
} as const;

export const MailTemplates = {
  DefaultInvoiceSubject: 'Invoice {InvoiceNumber} from {SenderName}',
  DefaultInvoiceBody: 'Hello {ContactName},\n\nPlease find invoice {InvoiceNumber} attached, for {Total}.\n{DueLine}{PayLine}\nIf you have any questions about this invoice, just reply to this message.\n\nThank you,\n{SenderName}',
} as const;

export const MarketingLimits = {
  MaxRecipients: 5000,
  MaxSubjectLength: 200,
  MaxBodyLength: 50000,
  MaxNameLength: 120,
  SendIntervalMilliseconds: 2000,
  PreviewSample: 10,
  FormPostsPerHour: 10,
  DefaultBody: 'Hello {FirstName},\n\n\n\n{Sender}',
} as const;

export const MobileLimits = {
  MaxPolicyNameChars: 80,
  MaxWifiNetworks: 10,
  MaxTemplateChars: 200,
  MaxLostTextChars: 400,
  MinPasscodeChars: 4,
  MaxPasscodeChars: 64,
  MaxEnrollmentDays: 90,
  LocationRetentionDays: 30,
  MaxStoredLocationsPerDevice: 2000,
  PullSeconds: 30,
  ReconcileMinutes: 60,
  OutlookPackage: 'com.microsoft.office.outlook',
  GmailPackage: 'com.google.android.gm',
  EnrollUrlBase: 'https://enterprise.google.com/android/enroll?et=',
} as const;

export const PaymentLimits = {
  DefaultCurrency: 'USD',
  MaxBrandNameChars: 127,
  MaxClientIdChars: 200,
  MaxClientSecretChars: 200,
} as const;

export const Recurrence = {
  MaxBackfill: 120,
} as const;

export const RemoteAgentMethods = {
  ReportScreenFrame: 'ReportScreenFrame',
  ReportThumbnail: 'ReportThumbnail',
  ReportClipboard: 'ReportClipboard',
  ReportClipboardFiles: 'ReportClipboardFiles',
} as const;

export const RemoteInputLimits = {
  MaxTextChars: 4096,
} as const;

export const RemoteUiMethods = {
  StartRemoteControl: 'StartRemoteControl',
  StopRemoteControl: 'StopRemoteControl',
  SendRemoteInput: 'SendRemoteInput',
  SendClipboard: 'SendClipboard',
  UpdateSessionOptions: 'UpdateSessionOptions',
} as const;

export const ServerUpdateLimits = {
  ProductId: 'JetsonCrmServer',
  ManifestFileName: 'crm-build.json',
  PackagedName: 'packaged',
  RestartExitCode: 99,
  DefaultCheckHours: 6,
  MinCheckHours: 1,
  MaxCheckHours: 720,
  DefaultKeepVersions: 3,
  MinKeepVersions: 1,
  MaxKeepVersions: 20,
  MaxSnapshots: 10,
} as const;

export const ServiceAgentMethods = {
  ListServices: 'ListServices',
  ControlService: 'ControlService',
  SetServiceStartupType: 'SetServiceStartupType',
  SetServiceRecovery: 'SetServiceRecovery',
  SetServiceAccount: 'SetServiceAccount',
} as const;

export const ServiceLimits = {
  MaxNameChars: 256,
  TransitionTimeoutSeconds: 30,
  MaxBulkDevices: 50,
  MaxResetSeconds: 31536000,
  MaxRestartDelaySeconds: 86400,
  MaxAccountChars: 256,
  MaxPasswordChars: 256,
  MaxStoppedServices: 50,
  LocalSystem: 'LocalSystem',
  LocalService: 'NT AUTHORITY\\LocalService',
  NetworkService: 'NT AUTHORITY\\NetworkService',
} as const;

export const ShellAgentMethods = {
  RunShellCommand: 'RunShellCommand',
} as const;

export const ShellLimits = {
  MaxCommandChars: 8000,
  MaxOutputChars: 200000,
  DefaultTimeoutSeconds: 60,
  MaxTimeoutSeconds: 900,
  MaxPathChars: 1000,
  MaxHistoryCommandChars: 400,
} as const;

export const SignInLimits = {
  MaxAlertLockoutsListed: 20,
  MaxAlertRecipients: 10,
} as const;

export const SnmpMonitorAgentMethods = {
  ReportMetrics: 'ReportMetrics',
  ReportMetricsHistory: 'ReportMetricsHistory',
  ReportMonitorMaintenanceSample: 'ReportMonitorMaintenanceSample',
  TestSnmp: 'TestSnmp',
} as const;

export const SoftwareDeploymentLimits = {
  MaxNameLength: 120,
  MaxVersionLength: 40,
  MaxPublisherLength: 120,
  MaxNotesLength: 2000,
  MaxUrlLength: 2000,
  MaxFileNameLength: 160,
  MaxArgumentsLength: 1000,
  MaxMessageLength: 600,
  MaxExitCodes: 16,
  MaxDevicesPerRequest: 200,
  MaxJobsPerDevice: 50,
  MinTimeoutMinutes: 1,
  MaxTimeoutMinutes: 240,
  DefaultTimeoutMinutes: 30,
} as const;

export const SoftwareInstallAgentMethods = {
  ReportInstallProgress: 'ReportInstallProgress',
} as const;

export const StaffRoles = {
  Admin: 'Admin',
  Staff: 'Staff',
} as const;

export const SynologyAgentMethods = {
  ReportSynologyInventory: 'ReportSynologyInventory',
  TestSynology: 'TestSynology',
} as const;

export const TenantLimits = {
  MaxNameLength: 100,
  MaxSlugLength: 40,
  MinPasswordLength: 8,
  DefaultTenantId: 1,
} as const;

export const TicketAlertLimits = {
  MaxRecipients: 10,
  MaxPerPass: 20,
} as const;

export const TicketStatusRules = {
  BillingRule: 'Time and charges are invoiced per ticket, and only once the ticket is resolved.',
} as const;

export const UiHubMethods = {
  WatchDevice: 'WatchDevice',
  UnwatchDevice: 'UnwatchDevice',
  WatchMonitor: 'WatchMonitor',
  UnwatchMonitor: 'UnwatchMonitor',
} as const;

export const WakeOnLan = {
  DefaultPort: 9,
  AltPort: 7,
  PacketBytes: 102,
  MaxMacsPerCommand: 8,
} as const;

export const WakeOnLanAgentMethods = {
  WakeDevice: 'WakeDevice',
} as const;

export const WindowsPolicyAgentMethods = {
  CheckWindowsPolicy: 'CheckWindowsPolicy',
} as const;

export const WindowsPolicyLimits = {
  MaxRecoveryKeysPerDevice: 20,
  MaxPolicyNameChars: 80,
  MaxChecks: 40,
  MaxTextChars: 300,
} as const;

// =====================================================================
//  Hub pushes: one entry per method the server calls on a connected client, with its
//  argument tuple, so a subscription's callback is typed from the contract rather
//  than from a method name somebody spelled twice.
// =====================================================================

export const AgentHubEvents = {
  ApplySettings: 'ApplySettings',
  DeployAgent: 'DeployAgent',
  InjectInput: 'InjectInput',
  InstallPendingUpdates: 'InstallPendingUpdates',
  InstallSoftware: 'InstallSoftware',
  InstallUpdate: 'InstallUpdate',
  Ping: 'Ping',
  RequestInventory: 'RequestInventory',
  RequestSoftwareInventory: 'RequestSoftwareInventory',
  RestartDevice: 'RestartDevice',
  ScanNetwork: 'ScanNetwork',
  SetClipboard: 'SetClipboard',
  SetClipboardFiles: 'SetClipboardFiles',
  SetDeviceLock: 'SetDeviceLock',
  SetMaintenanceMode: 'SetMaintenanceMode',
  SetSnmpMonitors: 'SetSnmpMonitors',
  SetSuspended: 'SetSuspended',
  SetWindowsPolicy: 'SetWindowsPolicy',
  StartLiveMetrics: 'StartLiveMetrics',
  StartRemoteSession: 'StartRemoteSession',
  StartThumbnails: 'StartThumbnails',
  StopLiveMetrics: 'StopLiveMetrics',
  StopRemoteSession: 'StopRemoteSession',
  StopThumbnails: 'StopThumbnails',
  Uninstall: 'Uninstall',
  UninstallPatch: 'UninstallPatch',
  UninstallSoftware: 'UninstallSoftware',
  UpdateAvailable: 'UpdateAvailable',
  UploadClipboardFiles: 'UploadClipboardFiles',
} as const;

export interface AgentHubPayloads {
  ApplySettings: [settings: AppSettingsDto];
  DeployAgent: [command: DeployAgentCommand];
  InjectInput: [input: RemoteInput];
  InstallPendingUpdates: [];
  InstallSoftware: [command: InstallSoftwareCommand];
  InstallUpdate: [updateId: string];
  Ping: [];
  RequestInventory: [];
  RequestSoftwareInventory: [];
  RestartDevice: [];
  ScanNetwork: [];
  SetClipboard: [payload: ClipboardPayload];
  SetClipboardFiles: [files: ClipboardFiles];
  SetDeviceLock: [spec: DeviceLockSpec | null];
  SetMaintenanceMode: [untilUtc: string | null];
  SetSnmpMonitors: [monitors: SnmpMonitorSpec[]];
  SetSuspended: [suspended: boolean];
  SetWindowsPolicy: [spec: WindowsPolicySpec | null];
  StartLiveMetrics: [];
  StartRemoteSession: [options: RemoteSessionOptions];
  StartThumbnails: [];
  StopLiveMetrics: [];
  StopRemoteSession: [];
  StopThumbnails: [];
  Uninstall: [];
  UninstallPatch: [hotFixId: string];
  UninstallSoftware: [command: UninstallSoftwareCommand];
  UpdateAvailable: [version: string];
  UploadClipboardFiles: [transferId: string];
}

export const UiHubEvents = {
  AgentDiagnosticsChanged: 'AgentDiagnosticsChanged',
  ClipboardChanged: 'ClipboardChanged',
  ClipboardFilesChanged: 'ClipboardFilesChanged',
  ClipboardFilesReady: 'ClipboardFilesReady',
  DesktopThumbnail: 'DesktopThumbnail',
  DeviceHistoryChanged: 'DeviceHistoryChanged',
  DeviceInventoryChanged: 'DeviceInventoryChanged',
  DevicePresenceChanged: 'DevicePresenceChanged',
  DiscoveryChanged: 'DiscoveryChanged',
  DisplaysChanged: 'DisplaysChanged',
  InputFocusChanged: 'InputFocusChanged',
  LiveMetricsChanged: 'LiveMetricsChanged',
  LiveMetricsHistoryChanged: 'LiveMetricsHistoryChanged',
  MonitorChanged: 'MonitorChanged',
  MonitorMetricsChanged: 'MonitorMetricsChanged',
  MonitorMetricsHistoryChanged: 'MonitorMetricsHistoryChanged',
  RemoteSessionChanged: 'RemoteSessionChanged',
  ScreenFrame: 'ScreenFrame',
  SoftwareInstallChanged: 'SoftwareInstallChanged',
  SoftwareInventoryChanged: 'SoftwareInventoryChanged',
  SoftwareUninstallCompleted: 'SoftwareUninstallCompleted',
  TicketCreated: 'TicketCreated',
} as const;

export interface UiHubPayloads {
  AgentDiagnosticsChanged: [customerId: number];
  ClipboardChanged: [payload: ClipboardPayload];
  ClipboardFilesChanged: [files: ClipboardFiles];
  ClipboardFilesReady: [transferId: string];
  DesktopThumbnail: [thumbnail: DesktopThumbnail];
  DeviceHistoryChanged: [deviceId: number];
  DeviceInventoryChanged: [deviceId: number];
  DevicePresenceChanged: [presence: DevicePresenceDto];
  DiscoveryChanged: [customerId: number];
  DisplaysChanged: [layout: DisplayLayout];
  InputFocusChanged: [state: RemoteFocusState];
  LiveMetricsChanged: [metrics: LiveMetrics];
  LiveMetricsHistoryChanged: [history: LiveMetricsHistory];
  MonitorChanged: [customerId: number];
  MonitorMetricsChanged: [sample: MetricsReport];
  MonitorMetricsHistoryChanged: [history: MonitorMetricsHistory];
  RemoteSessionChanged: [state: RemoteSessionState];
  ScreenFrame: [frame: ScreenFrame];
  SoftwareInstallChanged: [job: SoftwareInstallJobDto];
  SoftwareInventoryChanged: [deviceId: number];
  SoftwareUninstallCompleted: [result: SoftwareUninstallResult];
  TicketCreated: [ticket: TicketDto];
}

